(function () {
var CATALOG = [];
var __fcCatalogReady = false;
// Button stays live while the asset catalog loads; an early ask/chip/?ask= is queued and runs when it lands.
var __fcPending = null;

// FC compact catalog expander (keys + CDN prefix)
function expandFcCatalog(list) {
  var P = "https://cdn.shopify.com/s/files/1/1004/1448/8885/";
  var M = {t:"title",h:"handle",r:"roast",f:"flavors",a:"acidity",b:"body",w:"brew",c:"caffeine",n:"intensity",k:"kind",p:"price",i:"image",o:"origin",d:"notes",v:"video_url",s:"source"};
  for (var i = 0; i < list.length; i++) {
    var row = list[i], out = {}, k;
    for (k in row) {
      if (!Object.prototype.hasOwnProperty.call(row, k)) continue;
      var nk = M[k] || k, val = row[k];
      if (nk === "image" && typeof val === "string" && val && val.indexOf("http") !== 0) val = P + val;
      out[nk] = val;
    }
    list[i] = out;
  }
  return list;
}

var GEAR_FALLBACK = [];
try {
  GEAR_FALLBACK = JSON.parse(document.getElementById("fc-gear").textContent || "[]");
} catch (e) {
  GEAR_FALLBACK = [];
}

function inferRegion(sku) {
  var t = (String(sku.title || "") + " " + String(sku.handle || "")).toLowerCase();
  if (/ethiopia|kenya|tanzania|uganda|african|kahawa|kopi[\s-]?safari|mooney/.test(t)) return "africa";
  if (/colombia|columbia|guatemala|mexico|peru|honduras|nicaragua|costa|brazil|latin|dominican|el[\s-]?salvador|salvador|nighthawk|huey|bonanza|mustang|corsair|super[\s-]?patriot/.test(t)) return "latam";
  if (/bali|sumatra|papua|asian|indonesia/.test(t)) return "asia";
  return "";
}
function inferCountry(sku) {
  var t = (String(sku.title || "") + " " + String(sku.handle || "")).toLowerCase();
  if (/colombia|columbia|super[\s-]?patriot|faa[\s-]?agent/.test(t)) return "colombia";
  if (/ethiopia|mooney/.test(t)) return "ethiopia";
  if (/\bkenya\b/.test(t)) return "kenya";
  if (/tanzania/.test(t)) return "tanzania";
  if (/uganda/.test(t)) return "uganda";
  if (/guatemala|huey/.test(t)) return "guatemala";
  if (/\bmexico\b/.test(t)) return "mexico";
  if (/\bperu\b/.test(t)) return "peru";
  if (/honduras/.test(t)) return "honduras";
  if (/nicaragua/.test(t)) return "nicaragua";
  if (/costa/.test(t)) return "costa rica";
  if (/brazil|corsair/.test(t)) return "brazil";
  if (/dominican|nighthawk/.test(t)) return "dominican republic";
  if (/salvador|bonanza/.test(t)) return "el salvador";
  if (/\bbali\b/.test(t)) return "bali";
  if (/sumatra/.test(t)) return "sumatra";
  return "";
}
function enrichCatalogRegions() {
  var ci;
  for (ci = 0; ci < CATALOG.length; ci++) {
    CATALOG[ci].region = inferRegion(CATALOG[ci]);
  }
}

function looksLikeCoffeeProduct(p) {
  var type = String((p && p.product_type) || "").toLowerCase();
  var title = String((p && p.title) || "").toLowerCase();
  var tags = ((p && p.tags) || []).join(" ").toLowerCase();
  if (/syrup|tea|apparel|hat|coin|cup|mug|gear|shirt|hoodie|sticker/.test(type + " " + title)) return false;
  if (type === "coffee") return true;
  if (/blend|flavored|single origin|sample/.test(tags)) return true;
  return false;
}
function mergeLiveCoffee(p) {
  if (!p || !p.handle) return;
  var exists = false;
  var hi;
  for (hi = 0; hi < CATALOG.length; hi++) {
    if (CATALOG[hi].handle === p.handle) { exists = true; break; }
  }
  if (exists) return;
  if (!looksLikeCoffeeProduct(p)) return;
  var title = String(p.title || "").replace(/\u2014|\u2013/g, "-");
  var vendor = String(p.vendor || "");
  var isLeg = /legend|aviation/i.test(vendor + " " + p.handle + " " + title);
  var sku = {
    title: title,
    handle: p.handle,
    roast: "medium",
    flavors: ["chocolate", "nutty"],
    acidity: "med",
    body: "medium",
    brew: ["drip", "pour-over"],
    caffeine: /decaf/i.test(title + " " + p.handle) ? "decaf" : "full",
    intensity: 3,
    kind: /sample|flight of/i.test(title) ? "sample" : "single-origin",
    price: (p.variants && p.variants[0] && p.variants[0].price) || "",
    image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || "",
    source: isLeg ? "legendary" : "hornet",
    vendor: isLeg ? "legendary" : "hornet",
    available: !!(p.variants && p.variants.some(function (v) { return v.available; }))
  };
  sku.region = inferRegion(sku);
  CATALOG.push(sku);
}
function hydrateCatalog() {
  function page(n) {
    return fetch("/products.json?limit=250&page=" + n).then(function (r) {
      return r.ok ? r.json() : { products: [] };
    });
  }
  page(1).then(function (data) {
    var list = (data && data.products) || [];
    var i;
    for (i = 0; i < list.length; i++) mergeLiveCoffee(list[i]);
    if (list.length >= 250) {
      return page(2).then(function (d2) {
        var more = (d2 && d2.products) || [];
        var j;
        for (j = 0; j < more.length; j++) mergeLiveCoffee(more[j]);
      });
    }
  }).catch(function () {});
}
hydrateCatalog();

var BEST_SELLERS = "best-sellers-sample-pack-6bean-cowboy-breakfast-peru-mexico-bali";
var SAMPLE_PACK_VARIANT = "53083852898613";
var GEAR_PREF = [
  "pure-cotton-unisex-t-shirt-1",
  "snow-washed-oversized-cotton-t-shirt-1",
  "essential-fleece-mock-neck-crew-sweatshirt-1",
  "oversize-fleeced-hoodie-1"
];
var HORNET_STAPLES = ["6-bean-blend","cowboy-blend","breakfast-blend-2","house-blend","colombia","ethiopia-natural","bali-blue","gourmet-donut-shop","italian-roast"];
var HORNET_BOOST = 0.12;
var HORNET_MIN_COMPETITIVE = 28;
var DRINK_CHIPS = [
  { q: "Pour-over, bright and fruity", label: "Pour-over, bright & fruity" },
  { q: "Dark, no acid, drip", label: "Dark, no acid, drip" },
  { q: "Decaf after dinner", label: "Decaf after dinner" },
  { q: "Flavored, sweet", label: "Flavored, sweet" },
  { q: "Espresso, chocolate", label: "Espresso, chocolate" },
  { q: "Just talk", label: "Just talk" }
];
/* Starters that imply a path but often omit brew — default drip/Mr Coffee so Fly returns products. */
var STARTER_QS = {
  "First bag, not sure": 1,
  "Espresso, chocolate": 1,
  "Decaf after dinner": 1,
  "Flavored, sweet": 1,
  "Chocolate / nut / caramel": 1,
  "Fruit / floral / citrus": 1,
  "Earth / spice / cocoa": 1,
  "Sweet / flavored": 1,
  "Light and bright": 1,
  "Balanced medium": 1,
  "Dark and bold": 1
};
var REFINE_CHIPS = [
  { q: "Darker", label: "Darker" },
  { q: "Brighter", label: "Brighter" },
  { q: "Less acid", label: "Less acid" },
  { q: "More like that", label: "More like that" },
  { q: "Start over", label: "Start over" }
];
var GREET = "Tell us what flavors you like, coffee or not, and what you’re brewing in. We’ll match " + (window.FC_V2 ? "two bags" : "three bags") + " to you.";
var GRIND_CHIPS = [
  { q: "Whole bean", label: "Whole bean" },
  { q: "Ground", label: "Ground" }
];
var BREW_FOLLOWUP_CHIPS = [
  { q: "Mr. Coffee drip", label: "Mr. Coffee drip" },
  { q: "Pour-over", label: "Pour-over" },
  { q: "K-cups / pods", label: "K-cups / pods" },
  { q: "French press", label: "French press" }
];
var FLAVOR_CHIPS = [
  { q: "Fruit / floral / citrus", label: "Fruit / floral / citrus" },
  { q: "Chocolate / nut / caramel", label: "Chocolate / nut / caramel" },
  { q: "Earth / spice / cocoa", label: "Earth / spice / cocoa" },
  { q: "Sweet / flavored", label: "Sweet / flavored" }
];
var ROAST_CHIPS = [
  { q: "Light and bright", label: "Light and bright" },
  { q: "Balanced medium", label: "Balanced medium" },
  { q: "Dark and bold", label: "Dark and bold" }
];
var REGION_CHIPS = [
  { q: "Africa", label: "Africa" },
  { q: "Latin America", label: "Latin America" },
  { q: "Asia Pacific", label: "Asia Pacific" },
  { q: "No preference", label: "No preference" }
];
var LANE_FLAVORS = {
  fruit: ["fruity", "floral", "berry", "bright"],
  choc: ["chocolate", "nutty", "caramel"],
  earth: ["earthy", "spice", "chocolate"],
  sweet: []
};

var logEl = document.getElementById("fc-log");
var form = document.getElementById("fc-form");
var input = document.getElementById("fc-input");
var sendBtn = document.getElementById("fc-send");
var chips = document.getElementById("fc-chips");
var messages = [];
var busy = false;
var state = freshState();
var usage = { source: "", brief: "", recs: [] };
var shownHandles = [];

function clipBrief(s) {
  return String(s == null ? "" : s).replace(/\s+/g, " ").trim().slice(0, 200);
}

function fcBeacon(name, extra) {
  var payload = { e: String(name || ""), t: Date.now() };
  if (extra && typeof extra === "object") {
    var k;
    for (k in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, k) && k !== "e" && k !== "t") {
        var v = extra[k];
        if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") payload[k] = v;
      }
    }
  }
  try { console.log("[fc]", payload.e, payload); } catch (err) {}
  try {
    if (window.dataLayer && typeof window.dataLayer.push === "function") {
      window.dataLayer.push({ event: "fc_" + payload.e, fc: payload });
    }
  } catch (err) {}
  try {
    document.dispatchEvent(new CustomEvent("fc:beacon", { detail: payload }));
  } catch (err) {}
  /* 2026-10-23 v3: only the four fc_* events go to the Concierge /evt log. Whitelisted fields only: no email, no ask text. */
  try {
    var evName = "fc_" + payload.e;
    if (FC_EVT_NAMES[evName]) {
      var ev = { event: evName, source: payload.source ? String(payload.source) : undefined, sid: fcSid(), utm_source: fcUtm() };
      /* 2026-10-25 source tagging (Martin): referrer HOST only; page = path + utm_* params only (all other query params dropped) */
      try { if (document.referrer) { var rh = new URL(document.referrer).hostname; if (rh) ev.ref = String(rh).slice(0, 120); } } catch (e2) {}
      try {
        var qp = new URLSearchParams(location.search), keep = [];
        qp.forEach(function (v, k) { if (/^utm_[a-z_]+$/i.test(k)) keep.push(encodeURIComponent(k) + "=" + encodeURIComponent(String(v).slice(0, 60))); });
        if (qp.get("utm_medium")) ev.utm_medium = String(qp.get("utm_medium")).slice(0, 60);
        ev.page = location.pathname + (keep.length ? "?" + keep.join("&") : "");
      } catch (e3) {}
      if (typeof payload.brief_len === "number") ev.ask_len = payload.brief_len;
      if (payload.handle) ev.handle = String(payload.handle).slice(0, 120);
      if (payload.title) ev.title = String(payload.title).slice(0, 120);
      if (payload.price !== undefined && payload.price !== "" && !isNaN(parseFloat(payload.price))) ev.price = parseFloat(payload.price);
      var body = JSON.stringify(ev);
      var sent = false;
      if (navigator.sendBeacon) {
        try { sent = navigator.sendBeacon(FC_EVT_URL, new Blob([body], { type: "text/plain" })); } catch (e1) { sent = false; }
      }
      if (!sent && window.fetch) {
        fetch(FC_EVT_URL, { method: "POST", body: body, keepalive: true, mode: "cors", credentials: "omit", headers: { "Content-Type": "text/plain" } }).catch(function () {});
      }
    }
  } catch (err) {}
}

var FC_EVT_URL = "https://hornet-flight-concierge.fly.dev/evt";
var FC_EVT_NAMES = { fc_quiz_start: 1, fc_ask_sent: 1, fc_match_shown: 1, fc_add_my_match: 1, fc_buy_now: 1 };
function fcSid() {
  try {
    var s = sessionStorage.getItem("fc_evt_sid");
    if (!s) { s = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); sessionStorage.setItem("fc_evt_sid", s); }
    return s;
  } catch (e) { return undefined; }
}
function fcUtm() {
  try {
    var m = /[?&]utm_source=([^&#]*)/.exec(location.search);
    if (m) { var u = decodeURIComponent(m[1].replace(/\+/g, " ")).slice(0, 60); try { sessionStorage.setItem("fc_evt_utm", u); } catch (e2) {} return u; }
    return sessionStorage.getItem("fc_evt_utm") || undefined;
  } catch (e) { return undefined; }
}

function applyStarterBrew(text, prefs) {
  var q = String(text || "").trim();
  if (!prefs) return prefs;
  if (prefs.brew && prefs.brew.length) return prefs;
  var isStarter = !!STARTER_QS[q] || isDrinkChip(q);
  if (!isStarter) return prefs;
  prefs.brew = ["drip"];
  prefs.hot = true;
  return prefs;
}

function openCartDrawer() {
  ["cart:refresh", "cart:updated", "cart-drawer:open", "theme:cart:open"].forEach(function (n) {
    try { document.dispatchEvent(new CustomEvent(n)); } catch (err) {}
  });
  var drawer =
    document.querySelector("cart-drawer") ||
    document.querySelector("cart-notification") ||
    document.querySelector("#CartDrawer") ||
    document.querySelector("#cart-drawer") ||
    document.querySelector("[data-cart-drawer]") ||
    document.querySelector("cart-drawer-component");
  if (drawer) {
    var node = drawer, trapped = false;
    while (node && node !== document.body) {
      try {
        var st = getComputedStyle(node);
        if (st.display === "none" || st.visibility === "hidden") { trapped = true; break; }
      } catch (err) {}
      node = node.parentElement;
    }
    if (!trapped) {
      try { if (typeof drawer.open === "function") { drawer.open(); return true; } } catch (err) {}
      try { if (typeof drawer.show === "function") { drawer.show(); return true; } } catch (err) {}
      try { drawer.setAttribute("open", ""); drawer.classList.add("active", "is-open", "open"); return true; } catch (err) {}
    }
  }
  var toggle =
    document.querySelector('[href="/cart"][data-cart-toggle]') ||
    document.querySelector("button[data-cart-toggle]") ||
    document.querySelector('[aria-controls="CartDrawer"]') ||
    document.querySelector('a[href="#cart-drawer"]');
  if (toggle) {
    try { toggle.click(); return true; } catch (err) {}
  }
  return false;
}

function afterAtcOk(btn, label) {
  if (btn) {
    btn.textContent = label || "Added ✓";
    try { btn.classList.add("fc-add--ok"); } catch (err) {}
  }
  fcBeacon("atc_ok");
  fcCartCount().then(function () { openCartDrawer(); }, function () { openCartDrawer(); });
}

function fcCartCount() {
  return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
    .then(function (r) { return r.json(); })
    .then(function (c) {
      var n = (c && c.item_count) || 0;
      var b = document.getElementById("fc-cart-count");
      var L = document.getElementById("fc-cart-link");
      if (b) { b.textContent = n > 99 ? "99+" : String(n); b.hidden = n < 1; }
      if (L) L.setAttribute("aria-label", n > 0 ? "Cart, " + n + (n === 1 ? " item" : " items") : "Cart");
      window.fcCartN = n;
      try { if (window.fcStickySync) window.fcStickySync(); } catch (err) {}
      fcPinPage();
      return c;
    });
}

/* match-first 2026-10-23: Shopify custom pixel events (fc_quiz_start, fc_ask_sent, fc_match_shown, fc_add_my_match). No PII, no brief text. */
var fcPixState = { started: false };
function fcPub(name, data) {
  var d = data && typeof data === "object" ? data : {};
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(name, d);
    }
  } catch (e) {}
  try { fcBeacon(String(name).replace(/^fc_/, ""), d); } catch (e2) {}
}

function fcTrack(added) {
  var payload = {
    source: usage.source || "",
    brief_len: (usage.brief || "").length,
    added: !!added
  };
  /* 2026-10-23: legacy Shopify.analytics "flight_concierge" publish removed; fc_* via fcPub. Klaviyo track kept. */
  try {
    if (window.klaviyo) {
      if (typeof window.klaviyo.track === "function") {
        window.klaviyo.track("flight_concierge", payload);
      } else if (typeof window.klaviyo.push === "function") {
        window.klaviyo.push(["track", "flight_concierge", payload]);
      }
    }
  } catch (e) {}
}

function noteUsage(text, fromChip) {
  if (!usage.source) usage.source = fromChip ? "chip" : "text";
  else if (!fromChip) usage.source = "text";
  var clipped = clipBrief(text);
  if (!usage.brief) usage.brief = clipped;
  else if (clipped && usage.brief.indexOf(clipped) === -1) usage.brief = clipBrief(usage.brief + " " + clipped);
  if (!fcPixState.started) { fcPixState.started = true; fcPub("fc_quiz_start", { source: fromChip ? "chip" : (/[?&]ask=/.test(location.search) ? "ask_link" : "text") }); }
  fcPub("fc_ask_sent", { source: fromChip ? "chip" : "text", brief_len: (text || "").length });
  fcTrack(false);
}

function noteRecs(result) {
  var recs = [];
  var list = (result && result.products) || [];
  var i;
  for (i = 0; i < list.length && recs.length < 3; i++) {
    if (list[i] && list[i].handle) recs.push(String(list[i].handle));
  }
  usage.recs = recs;
  for (i = 0; i < recs.length; i++) {
    if (shownHandles.indexOf(recs[i]) === -1) shownHandles.push(recs[i]);
  }
  if (shownHandles.length > 18) shownHandles = shownHandles.slice(-12);
}


function freshState() {
  return {
    step: "drink",
    prefs: null,
    grind: null,
    lastText: "",
    lastResult: null,
    gearShown: false,
    probesAsked: 0,
    asked: { flavor: false, roast: false, region: false }
  };
}

function isDrinkChip(text) {
  var i;
  for (i = 0; i < DRINK_CHIPS.length; i++) {
    if (DRINK_CHIPS[i].q === text) return true;
  }
  return false;
}

function resetToGreeting(extra) {
  state = freshState();
  messages = [];
  shownHandles = [];
  usage = { source: "", brief: "", recs: [] };
  logEl.innerHTML = "";
  addBubble("bot", "<p>" + esc(extra || GREET) + "</p>");
  setTimeout(function () { setChips(DRINK_CHIPS); }, 80);
}

function beginNewSearch(text) {
  resetToGreeting("New brief. Tell us what flavors you like, coffee or not, and what you’re brewing in. We’ll match " + (window.FC_V2 ? "two bags" : "three bags") + " to you.");
  state.grind = "skip";
  state.lastText = text;
}

function isResetChip(text) {
  return /^(start over|new brief)$/i.test(String(text || "").trim());
}

function byHandle(handle) {
  for (var i = 0; i < CATALOG.length; i++) {
    if (CATALOG[i].handle === handle) return CATALOG[i];
  }
  return null;
}

// Ready Room Club only. Numeric SellingPlan id (not the group). Exact handles, not titles.
var READY_ROOM_PLAN = "710931743029";
var READY_ROOM_HANDLES = {
  "italian-roast": 1,
  "6-bean-blend": 1,
  "60-pack-single-serve-coffee-capsules": 1,
  "breakfast-blend-1": 1,
  "house-blend": 1,
  "gourmet-donut-shop": 1,
  "cowboy-blend": 1,
  "bali-blue": 1,
  "colombia": 1,
  "ethiopia-natural": 1,
  "peru-decaf": 1
};

function readyRoomPlanFor(handle) {
  if (!READY_ROOM_PLAN || !/^\d+$/.test(String(READY_ROOM_PLAN))) return "";
  if (!handle || !READY_ROOM_HANDLES[handle]) return "";
  return String(READY_ROOM_PLAN);
}

function clubPriceText(priceStr) {
  var n = parseFloat(String(priceStr == null ? "" : priceStr).replace(/[^0-9.]/g, ""));
  if (!isFinite(n) || n <= 0) return "";
  var cents = Math.round(n * 100);
  var club = Math.round(cents * 90 / 100);
  return "$" + (club / 100).toFixed(2);
}
function clubBtn(h, p) {
  var planId = readyRoomPlanFor(h), club = planId ? clubPriceText(p) : "";
  return planId && club ? '<button type="button" class="fc-add fc-add--one fc-add--club" data-add="' + esc(h) + '" data-selling-plan="' + esc(planId) + '">Subscribe<span class="fc-rr"> · Ready Room Club</span> · ' + club + "/mo</button>" : "";
}
function monthlyAdd(bub, ps) {
  var L = [], h, k, s, i;
  for (i = 0; i < ps.length; i++) if (readyRoomPlanFor(ps[i].handle)) return;
  for (h in READY_ROOM_HANDLES) {
    k = byHandle(h);
    if (!k || k.available === false || !clubBtn(h, k.price)) continue;
    s = 0;
    ps.forEach(function (p) {
      var m = p.sku || byHandle(p.handle) || {};
      if (m.caffeine !== k.caffeine || (m.kind === "pods") !== (k.kind === "pods")) return;
      if (m.roast && m.roast === k.roast) s += 2;
      (m.flavors || []).forEach(function (f) { if ((k.flavors || []).indexOf(f) > -1) s++; });
    });
    if (s) L.push([s, k]);
  }
  L.sort(function (x, y) { return y[0] - x[0]; });
  (function next(i) {
    var k = L[i] && L[i][1];
    if (k) fetchPjs(k.handle).then(function (p) {
      var v = pickVariant(p, state.prefs, state.grind).variant || {}, w = bub.querySelector(".fc-wingman-note");
      if (!v.available || !(v.selling_plan_allocations || []).some(function (a) { return a.selling_plan_id == READY_ROOM_PLAN && "$" + (a.price / 100).toFixed(2) == clubPriceText(k.price); })) return next(i + 1);
      if (w) w.insertAdjacentHTML("beforebegin", '<div class="fc-monthly"><p>Make it monthly: ' + esc(k.title) + ", closest club match.</p>" + clubBtn(k.handle, k.price) + "</div>");
    }, function () { next(i + 1); });
  })(0);
}
function esc(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function shopUrl(handle) {
  return "/products/" + encodeURIComponent(handle);
}

function isNarrow() {
  return window.matchMedia && window.matchMedia("(max-width: 640px)").matches;
}

function blurInputs() {
  try {
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
  } catch (e) {}
  if (input && input.blur) input.blur();
}

function afterRoute(fromChip) {
  if (fromChip || isNarrow()) {
    blurInputs();
    return;
  }
}

function setChips(list) {
  list = list || [];
  if (!list.length) {
    chips.innerHTML = "";
    chips.classList.add("fc-chips--hidden");
    chips.setAttribute("aria-hidden", "true");
    return;
  }
  chips.classList.remove("fc-chips--hidden");
  chips.removeAttribute("aria-hidden");
  chips.innerHTML = list.map(function (it) {
    var extra = it.href ? ' data-href="' + esc(it.href) + '"' : "";
    return (
      '<button type="button" class="fc-chip" data-q="' +
      esc(it.q) +
      '"' +
      extra +
      ">" +
      esc(it.label) +
      "</button>"
    );
  }).join("");
}

function parseGrind(text) {
  var q = String(text || "").toLowerCase();
  if (/(whole\s*bean|wholebean)/.test(q)) return "whole";
  if (/\bwhole\b/.test(q) && /bean/.test(q)) return "whole";
  if (/\bground\b|\bpre[-\s]?ground\b/.test(q)) return "ground";
  return null;
}

function skipGrind(prefs, text) {
  var q = String(text || "").toLowerCase();
  if (!prefs) return false;
  if (prefs.kind.indexOf("instant") !== -1) return true;
  if (prefs.kind.indexOf("sample") !== -1) return true;
  if (prefs.brew.indexOf("pods") !== -1) return true;
  if (/(pod|k-?cup|keurig|capsule|nespresso|single[-\s]?serve|\binstant\b)/.test(q)) return true;
  return false;
}

function normalizeAsk(text) {
  return String(text || "").toLowerCase()
    .replace(/\bcarmel\b/g, "caramel")
    .replace(/\bvanila\b/g, "vanilla")
    .replace(/\bcolumbian\b/g, "colombian")
    .replace(/\bcolumbia\b/g, "colombia")
    .replace(/\breces\b/g, "reeses")
    .replace(/\breese'?s\b/g, "reeses")
    .replace(/\breeses\b/g, "reeses")
    .replace(/\breese\b/g, "reeses");
}
function isDessertAsk(text, prefs) {
  var q = normalizeAsk(text || (prefs && prefs._q) || "");
  return /caramel|vanilla|honey|dessert|toffee|brown\s+sugar/.test(q);
}
function mintHolidaySku(sku) {
  var blob = (String((sku && sku.title) || "") + " " + String((sku && sku.handle) || "") + " " + ((sku && sku.flavors) || []).join(" ")).toLowerCase();
  return /candy[\s-]?cane|\bmint\b|peppermint|holiday/.test(blob);
}

function parsePrefs(text) {
  var q = normalizeAsk(text);
  var prefs = {
    brew: [],
    roast: [],
    flavors: [],
    body: [],
    acidity: [],
    kind: [],
    decaf: false,
    unsure: false,
    lane: "",
    region: "",
    regionAny: false,
    country: "",
    hot: false,
    avoid: []
  };

  if (/(not sure|unsure|first bag|new to|don'?t know|no idea|help me|beginner|idk|what should)/.test(q)) {
    prefs.unsure = true;
  }
  if (/(pour[-\s]?over|v60|chemex|kalita)/.test(q)) prefs.brew.push("pour-over");
  if (/\bdrip\b|auto[-\s]?drip|coffee maker|mr\.?\s*coffee|mister\s+coffee|hot\s+(coffee|brew|cup)|brewed\s+hot|\bhot brew\b/.test(q)) prefs.brew.push("drip");
  if (/\bhot\b/.test(q) && /coffee|brew|cup|drip/.test(q) && !/shot|hotel|chocolate/.test(q)) prefs.hot = true;
  if (/(espresso|latte|cappuccino|americano|flat white|cortado|shot)/.test(q)) prefs.brew.push("espresso");
  if (/(french[-\s]?press|plunger)/.test(q)) prefs.brew.push("french-press");
  if (/(aero[-\s]?press)/.test(q)) prefs.brew.push("aero-press");
  if (/(cold[-\s]?brew)/.test(q)) prefs.brew.push("cold-brew");
  if (/(pod|k-?cup|keurig|capsule|nespresso|single[-\s]?serve)/.test(q)) prefs.brew.push("pods");
  if (/\binstant\b/.test(q)) prefs.kind.push("instant");

  if (/\bblonde\b/.test(q) || (/\blight\b/.test(q) && !/light body/.test(q)) || /\bbrighter\b/.test(q)) prefs.roast.push("light");
  if (/medium[-\s]?dark/.test(q)) prefs.roast.push("medium-dark");
  else if (/\bmedium\b/.test(q) || /\bbalanced\b/.test(q)) prefs.roast.push("medium");
  if (/\bdark\b|\bdarker\b|\bfrench\b|\bitalian\b|\bbold\b|\bbolder\b/.test(q)) prefs.roast.push("dark");
  if (/\bbrighter\b/.test(q)) {
    prefs.acidity.push("high");
    if (!prefs.lane) prefs.lane = "fruit";
  }

  if (/fruit\s*\/\s*floral|floral\s*\/\s*citrus/.test(q)) prefs.lane = "fruit";
  else if (/chocolate\s*\/\s*nut|nut\s*\/\s*caramel/.test(q)) prefs.lane = "choc";
  else if (/earth\s*\/\s*spice|spice\s*\/\s*cocoa/.test(q)) prefs.lane = "earth";
  else if (/sweet\s*\/\s*flavou?red/.test(q)) prefs.lane = "sweet";

  if (/no preference|any region|no pref/.test(q)) {
    prefs.regionAny = true;
  } else if (/ethiopia|kenya|tanzania|uganda|\bafrica\b|african|kahawa|kopi[\s-]?safari/.test(q)) {
    prefs.region = "africa";
  } else if (/colombia|columbia|columbian|colombian|guatemala|mexico|peru|honduras|nicaragua|costa|brazil|latin|dominican|el[\s-]?salvador/.test(q)) {
    prefs.region = "latam";
  } else if (/bali|sumatra|papua|asian|indonesia|asia pacific|\basia\b/.test(q)) {
    prefs.region = "asia";
  }
  prefs.brand = "";
  if (/(legend|aviation|aircraft|mooney|corsair|nighthawk|huey|bonanza|mustang|faa agent|tarrazu)/.test(q)) {
    prefs.brand = "legendary";
  }
  if (/colombia|columbia|columbian|colombian/.test(q)) prefs.country = "colombia";
  else if (/ethiopia/.test(q)) prefs.country = "ethiopia";
  else if (/\bkenya\b/.test(q)) prefs.country = "kenya";
  else if (/tanzania/.test(q)) prefs.country = "tanzania";
  else if (/uganda/.test(q)) prefs.country = "uganda";
  else if (/guatemala/.test(q)) prefs.country = "guatemala";
  else if (/\bmexico\b/.test(q)) prefs.country = "mexico";
  else if (/\bperu\b/.test(q)) prefs.country = "peru";
  else if (/honduras/.test(q)) prefs.country = "honduras";
  else if (/nicaragua/.test(q)) prefs.country = "nicaragua";
  else if (/costa\s*rica|\bcosta\b/.test(q)) prefs.country = "costa rica";
  else if (/brazil/.test(q)) prefs.country = "brazil";
  else if (/\bbali\b/.test(q)) prefs.country = "bali";
  else if (/sumatra/.test(q)) prefs.country = "sumatra";

  function flavorHit(q, re) {
    var copy = new RegExp(re.source);
    var m = copy.exec(q);
    if (!m) return false;
    var before = q.slice(0, m.index);
    if (/(?:^|[^a-z])(?:no|not|without|less)\s+$/.test(before)) return false;
    return true;
  }
  if (/reeses|peanut\s*butter|pb\s*cups?|snickers|twix|butterfinger/.test(q)) {
    if (prefs.flavors.indexOf("chocolate") === -1) prefs.flavors.push("chocolate");
    if (prefs.flavors.indexOf("nutty") === -1) prefs.flavors.push("nutty");
    if (!prefs.lane) prefs.lane = "choc";
  }
  if (/skittles?|starburst|gummy\s*fruit|fruity\s*candy/.test(q)) {
    if (prefs.flavors.indexOf("fruity") === -1) prefs.flavors.push("fruity");
    if (prefs.flavors.indexOf("berry") === -1) prefs.flavors.push("berry");
    if (prefs.flavors.indexOf("bright") === -1) prefs.flavors.push("bright");
    if (!prefs.lane) prefs.lane = "fruit";
  }
  if (/cookies?\s*(and|&)\s*cream/.test(q)) {
    if (prefs.flavors.indexOf("chocolate") === -1) prefs.flavors.push("chocolate");
    if (prefs.flavors.indexOf("vanilla") === -1) prefs.flavors.push("vanilla");
    if (!prefs.lane) prefs.lane = "sweet";
  }
  var flavorMap = [
    ["chocolate", /chocolate|mocha|cocoa|reeses/],
    ["nutty", /nutty|hazelnut|pecan|almond|peanut|\bnut\b/],
    ["fruity", /fruit(?!ed)|fruity/],
    ["berry", /berry|berries/],
    ["floral", /floral|jasmine/],
    ["earthy", /earth|herbal/],
    ["caramel", /caramel|carmel|toffee|butterscotch|brown\s+sugar/],
    ["spice", /spicy|more\s+spice|spice|spiced|cinnamon|pumpkin/],
    ["vanilla", /vanilla|vanila/],
    ["honey", /honey/],
    ["mint", /\bmint\b|peppermint|candy\s*cane/],
    ["bright", /bright|citrus/]
  ];
  for (var i = 0; i < flavorMap.length; i++) {
    if (flavorHit(q, flavorMap[i][1])) prefs.flavors.push(flavorMap[i][0]);
  }
  var avoidRe = /(?:^|[^a-z])(?:no|not|without|less)\s+(chocolate|mocha|cocoa|hazelnut|nutty)/g;
  var am;
  while ((am = avoidRe.exec(q))) {
    var tok = am[1];
    if (prefs.avoid.indexOf("chocolate") === -1) prefs.avoid.push("chocolate");
    if ((tok === "hazelnut" || tok === "nutty") && prefs.avoid.indexOf("nutty") === -1) prefs.avoid.push("nutty");
  }
  if (/spicy|more\s+spice|\bspiced\b/.test(q)) {
    if (prefs.flavors.indexOf("spice") === -1) prefs.flavors.push("spice");
    if (prefs.lane !== "fruit" && prefs.region !== "africa") prefs.lane = "earth";
  }

  if (/(decaf|no caffeine|without caffeine|after dinner|evening cup|night)/.test(q)) prefs.decaf = true;
  if (/\bflavou?red\b/.test(q) || (/\bsweet\b/.test(q) && prefs.flavors.length === 0 && !/caramel|vanilla|honey|dessert/.test(q))) {
    prefs.kind.push("flavored");
  }
  if (/(sample|flight|variety|try a few|first bag)/.test(q) || prefs.unsure) prefs.kind.push("sample");

  if (/full body|heavy|thick/.test(q)) prefs.body.push("full");
  if (/light body/.test(q)) prefs.body.push("light");
  if (/(no acid|low acid|less acid|not acidic|smooth|mellow)/.test(q)) prefs.acidity.push("low");
  if (/(high acid|bright|citrus)/.test(q)) prefs.acidity.push("high");

  if (!prefs.lane) {
    if (prefs.flavors.indexOf("caramel") !== -1 || prefs.flavors.indexOf("vanilla") !== -1 || prefs.flavors.indexOf("honey") !== -1 || /dessert/.test(q)) {
      prefs.lane = "sweet";
    } else if (prefs.flavors.indexOf("fruity") !== -1 || prefs.flavors.indexOf("floral") !== -1 || prefs.flavors.indexOf("berry") !== -1 || /citrus/.test(q)) {
      prefs.lane = "fruit";
    } else if (prefs.kind.indexOf("flavored") !== -1) {
      prefs.lane = "sweet";
    } else if (prefs.flavors.indexOf("earthy") !== -1 || prefs.flavors.indexOf("spice") !== -1) {
      prefs.lane = "earth";
    } else if (prefs.flavors.indexOf("chocolate") !== -1 || prefs.flavors.indexOf("nutty") !== -1) {
      prefs.lane = "choc";
    }
  }
  var laneFlav = LANE_FLAVORS[prefs.lane] || [];
  var lf;
  for (lf = 0; lf < laneFlav.length; lf++) {
    if (prefs.avoid.indexOf("chocolate") !== -1 && /chocolate|mocha|cocoa|nutty/.test(laneFlav[lf])) continue;
    if (prefs.avoid.indexOf(laneFlav[lf]) !== -1) continue;
    if (prefs.flavors.indexOf(laneFlav[lf]) === -1) prefs.flavors.push(laneFlav[lf]);
  }
  if (prefs.avoid.indexOf("chocolate") !== -1) {
    var stripped = [];
    for (lf = 0; lf < prefs.flavors.length; lf++) {
      if (!/^(chocolate|mocha|cocoa|nutty)$/.test(prefs.flavors[lf])) stripped.push(prefs.flavors[lf]);
    }
    prefs.flavors = stripped;
    if (prefs.lane === "choc") prefs.lane = "earth";
  }
  if (prefs.lane === "sweet" && prefs.kind.indexOf("flavored") === -1 && prefs.flavors.indexOf("caramel") === -1 && prefs.flavors.indexOf("vanilla") === -1 && prefs.flavors.indexOf("honey") === -1) {
    prefs.kind.push("flavored");
  }

  return prefs;
}

function mergePrefs(base, extra) {
  if (!base) return extra;
  var out = {
    brew: base.brew.slice(),
    roast: base.roast.slice(),
    flavors: base.flavors.slice(),
    body: base.body.slice(),
    acidity: base.acidity.slice(),
    kind: base.kind.slice(),
    decaf: base.decaf || extra.decaf,
    unsure: base.unsure || extra.unsure,
    lane: extra.lane || base.lane || "",
    region: extra.region || base.region || "",
    regionAny: !!(base.regionAny || extra.regionAny),
    brand: extra.brand || base.brand || "",
    country: extra.country || base.country || "",
    hot: !!(extra.hot || base.hot),
    avoid: (base.avoid || []).slice(),
    _q: extra._q != null ? extra._q : (base._q || "")
  };
  function addAll(key) {
    for (var i = 0; i < extra[key].length; i++) {
      if (out[key].indexOf(extra[key][i]) === -1) out[key].push(extra[key][i]);
    }
  }
  addAll("brew");
  if (extra.roast && extra.roast.length) out.roast = extra.roast.slice();
  else addAll("roast");
  var flavorReplace = isDessertAsk(extra._q, extra);
  if (flavorReplace) {
    out.flavors = extra.flavors.slice();
    out.brand = extra.brand || "";
    out.lane = extra.lane || "sweet";
    if (!extra.region) out.region = "";
    if (!extra.country) out.country = "";
  } else {
    addAll("flavors");
  }
  addAll("body");
  if (extra.acidity && extra.acidity.length) out.acidity = extra.acidity.slice();
  else addAll("acidity");
  addAll("kind");
  var ev = extra.avoid || [];
  var ai;
  for (ai = 0; ai < ev.length; ai++) {
    if (out.avoid.indexOf(ev[ai]) === -1) out.avoid.push(ev[ai]);
  }
  if (out.avoid.indexOf("chocolate") !== -1) {
    var keptFlav = [];
    for (var fi = 0; fi < out.flavors.length; fi++) {
      if (!/^(chocolate|mocha|cocoa|nutty)$/.test(out.flavors[fi])) keptFlav.push(out.flavors[fi]);
    }
    out.flavors = keptFlav;
    if (out.lane === "choc") out.lane = extra.lane || "earth";
  }
  if (extra.lane) out.lane = extra.lane;
  out._q = extra._q != null ? extra._q : (base._q || "");
  return out;
}

function sourceOf(sku) {
  return (sku && sku.source) || "hornet";
}

function scoreSku(sku, prefs, rawOnly) {
  var score = 0;
  if (prefs.decaf) {
    score += sku.caffeine === "decaf" ? 50 : -80;
  } else if (sku.caffeine === "decaf") {
    score -= 18;
  }
  var b;
  for (b = 0; b < prefs.brew.length; b++) {
    if (sku.brew.indexOf(prefs.brew[b]) !== -1) score += 26;
    if (prefs.brew[b] === "pods" && sku.kind === "pods") score += 20;
    if (prefs.brew[b] === "cold-brew" && sku.kind !== "pods") score += 8;
  }
  var r;
  for (r = 0; r < prefs.roast.length; r++) {
    if (sku.roast === prefs.roast[r]) score += 22;
    else if (prefs.roast[r] === "dark" && sku.roast === "medium-dark") score += 16;
    else if (prefs.roast[r] === "light" && sku.roast === "medium") score += 4;
  }
  var f;
  for (f = 0; f < prefs.flavors.length; f++) {
    if (sku.flavors.indexOf(prefs.flavors[f]) !== -1) score += 14;
  }
  var dessertAsk = isDessertAsk(prefs._q, prefs);
  var flavS = (sku.flavors || []).join(" ").toLowerCase();
  var blobS = (String(sku.title || "") + " " + String(sku.handle || "") + " " + flavS + " " + String(sku.notes || "")).toLowerCase();
  if (dessertAsk) {
    var wantCar = prefs.flavors.indexOf("caramel") !== -1 || /caramel/.test(normalizeAsk(prefs._q || ""));
    var wantVan = prefs.flavors.indexOf("vanilla") !== -1 || /vanilla/.test(normalizeAsk(prefs._q || ""));
    if (wantCar && (/caramel|toffee|honey|brown sugar/.test(flavS) || /caramel|toffee/.test(blobS))) score += 28;
    if (wantVan && (/vanilla/.test(flavS) || /vanilla/.test(blobS))) score += 28;
    if (wantCar && wantVan && /caramel/.test(flavS) && /vanilla/.test(flavS)) score += 18;
    if (wantCar && /(?:^|[^a-z])caramel(?:[^a-z]|$)/.test(blobS)) score += 24;
    if (wantVan && /(?:^|[^a-z])(?:french\s+)?vanilla(?:[^a-z]|$)/.test(blobS)) score += 24;
    if (wantCar && sku.handle === "caramel") score += 36;
    if (wantVan && sku.handle === "french-vanilla") score += 36;
    if (mintHolidaySku(sku) && !/mint|peppermint|holiday|candy/.test(normalizeAsk(prefs._q || ""))) score -= 90;
    if (sku.kind === "sample") score -= 50;
    if (/mexican-chocolate|mexican chocolate/.test(blobS) && prefs.flavors.indexOf("chocolate") === -1) score -= 40;
    if (sku.acidity === "high" && /fruity|berry/.test(flavS) && !/vanilla/.test(flavS)) score -= 24;
    if (prefs.brew && prefs.brew.length) score -= 16;
  }
  var k;
  for (k = 0; k < prefs.kind.length; k++) {
    if (sku.kind === prefs.kind[k]) score += 24;
  }
  if (prefs.kind.indexOf("flavored") !== -1 && sku.kind !== "flavored" && sku.kind !== "sample") score -= 16;
  if (prefs.brew.indexOf("pods") !== -1 && sku.kind !== "pods") score -= 20;
  if (prefs.brew.indexOf("pour-over") !== -1 && sku.kind === "flavored") score -= 10;
  var a;
  for (a = 0; a < prefs.acidity.length; a++) {
    if (sku.acidity === prefs.acidity[a]) score += 14;
    if (prefs.acidity[a] === "low" && sku.acidity === "high") score -= 16;
  }
  var bd;
  for (bd = 0; bd < prefs.body.length; bd++) {
    if (sku.body === prefs.body[bd]) score += 10;
  }
  if (prefs.unsure) {
    if (sku.kind === "sample") score += 36;
    if (sku.handle === BEST_SELLERS) score += 22;
  }
  if (sku.kind === "sample" && !prefs.unsure && prefs.kind.indexOf("sample") === -1) score -= 4;
  if (sku.kind === "instant" && prefs.kind.indexOf("instant") === -1) score -= 8;
  var skuRegion = sku.region || inferRegion(sku);
  if (prefs.region && skuRegion && prefs.region === skuRegion) score += 20;
  var skuCountry = sku.country || inferCountry(sku);
  if (prefs.country) {
    var blobC = (String(sku.title || "") + " " + String(sku.handle || "")).toLowerCase();
    if (skuCountry === prefs.country || blobC.indexOf(prefs.country) !== -1) score += 42;
    else score -= 10;
  }
  if (prefs.hot || (prefs.brew && prefs.brew.indexOf("drip") !== -1 && prefs.brew.indexOf("cold-brew") === -1)) {
    if (sku.brew && sku.brew.indexOf("drip") !== -1) score += 12;
    if (sku.brew && sku.brew.indexOf("cold-brew") !== -1 && sku.brew.length === 1) score -= 36;
  }
  if (prefs.avoid && prefs.avoid.indexOf("chocolate") !== -1) {
    var blobA = (String(sku.title || "") + " " + String(sku.handle || "")).toLowerCase();
    var flavA = (sku.flavors || []).join(" ").toLowerCase();
    if (/chocolate|mocha|cocoa|hazelnut/.test(blobA) || /chocolate|mocha|cocoa|hazelnut/.test(flavA)) {
      score -= 80;
    }
    if (sku.kind === "flavored" && /chocolate|mocha|cocoa|hazelnut/.test(blobA + " " + flavA)) {
      score -= 40;
    }
  }
  if (prefs.flavors && prefs.flavors.indexOf("spice") !== -1 && sku.flavors && sku.flavors.indexOf("spice") !== -1) score += 16;
  if (prefs.lane === "earth" && sku.flavors && (sku.flavors.indexOf("earthy") !== -1 || sku.flavors.indexOf("spice") !== -1)) score += 12;
  if (prefs.acidity && prefs.acidity.indexOf("low") !== -1 && sku.acidity === "low") score += 8;
  if (prefs.lane === "fruit") {
    if (sku.roast === "light") score += 12;
    if (skuRegion === "africa") score += 12;
  } else if (prefs.lane === "choc") {
    if (sku.roast === "medium" || sku.roast === "medium-dark") score += 10;
    if (skuRegion === "latam") score += 12;
  } else if (prefs.lane === "earth") {
    if (sku.roast === "medium-dark" || sku.roast === "dark") score += 10;
    if (skuRegion === "asia") score += 12;
  } else if (prefs.lane === "sweet") {
    if (!dessertAsk && sku.kind === "flavored") score += 16;
  }
  var qBrand = normalizeAsk((prefs && prefs._q) || "");
  if (prefs.brand === "legendary" && /legend|aviation/.test(qBrand) && sourceOf(sku) === "legendary") score += 40;
  if (sourceOf(sku) === "legendary" && prefs.roast && prefs.roast.indexOf("dark") !== -1 && (sku.roast === "dark" || sku.roast === "medium-dark")) score += 14;
  if (sourceOf(sku) === "legendary" && prefs.acidity && prefs.acidity.indexOf("low") !== -1 && sku.acidity === "low") score += 8;
  if (rawOnly) return score;
  var source = sourceOf(sku);
  if (source === "trade") return score;
  if (source === "hornet") {
    score = Math.round(score * (1 + HORNET_BOOST));
    if (HORNET_STAPLES.indexOf(sku.handle) !== -1) score += 4;
  }
  var q = String((prefs && prefs._q) || "").toLowerCase();
  if (q) {
    var blob = (String(sku.title || "") + " " + String(sku.handle || "") + " " + String(sku.source || "") + " " + String(sku.vendor || "")).toLowerCase();
    var words = q.split(/[^a-z0-9]+/);
    var wi;
    for (wi = 0; wi < words.length; wi++) {
      var word = words[wi] === "columbia" ? "colombia" : words[wi];
      if (word === "carmel") word = "caramel";
      if (word === "vanila") word = "vanilla";
      if (prefs.avoid && prefs.avoid.indexOf("chocolate") !== -1 && /chocolate|mocha|cocoa|hazelnut|nutty/.test(word)) continue;
      if (prefs.avoid && prefs.avoid.indexOf(word) !== -1) continue;
      if (/^(like|what|kind|coffee|matches|that|this|more|close|whats|with|from|have|just|some|want|show|bags|flavor|flavored|flavour)$/.test(word)) continue;
      if (word.length >= 4 && blob.indexOf(word) !== -1) score += 12;
    }
  }
  if ((!prefs.flavors || prefs.flavors.length === 0) && !prefs.decaf && sku.kind === "blend" && source === "hornet") {
    score += 4;
  }
  return score;
}

function originBit(sku) {
  var title = String(sku.title || "");
  var m = title.match(/Ethiopia|Kenya|Tanzania|Uganda|Colombia|Guatemala|Mexico|Peru|Honduras|Nicaragua|Costa Rica|Brazil|Dominican Republic|El Salvador|Bali|Sumatra|Papua New Guinea|Africa|Latin America|Asia/i);
  if (m) return m[0];
  var r = sku.region || inferRegion(sku);
  if (r === "africa") return "Africa";
  if (r === "latam") return "Latin America";
  if (r === "asia") return "Asia Pacific";
  return "";
}

function capBit(s) {
  s = String(s || "");
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function roastLabel(roast) {
  if (roast === "medium-dark") return "Medium-dark roast";
  if (roast === "light") return "Light roast";
  if (roast === "dark") return "Dark roast";
  if (roast === "medium") return "Medium roast";
  return roast ? capBit(roast) + " roast" : "";
}

function brewBit(prefs, sku) {
  var brew = "";
  if (prefs && prefs.brew && prefs.brew.length) brew = prefs.brew[0];
  else if (sku && sku.brew && sku.brew.length) brew = sku.brew[0];
  if (brew === "pour-over") return "pour-over";
  if (brew === "french-press") return "french press";
  if (brew === "aero-press") return "AeroPress";
  if (brew === "cold-brew") return "cold brew";
  if (brew === "espresso") return "espresso";
  if (brew === "pods") return "pods";
  if (brew === "drip") return "drip";
  return brew ? String(brew).replace(/-/g, " ") : "";
}

function shortName(sku) {
  var origin = originBit(sku);
  if (origin) return origin;
  var title = String((sku && sku.title) || "").split("|")[0].split(":")[0].trim();
  title = title.replace(/\s+/g, " ");
  if (title.length > 28) title = title.slice(0, 26).replace(/\s+\S*$/, "");
  return title || "This bag";
}

function reasonFor(sku, prefs) {
  prefs = prefs || {};
  var brew = brewBit(prefs, sku);
  var name = shortName(sku);
  if (sku.kind === "sample") {
    if (sku.handle === BEST_SELLERS) return "Six staples in one flight if you are still deciding.";
    return "A short flight so you can find the cup that holds.";
  }
  if (prefs.decaf || sku.caffeine === "decaf") {
    return name !== "This bag" ? "Decaf " + name + " for after dinner." : "Decaf for after dinner.";
  }
  if (isDessertAsk(prefs._q, prefs)) {
    var hits = [];
    var hf;
    var wantCarR = prefs.flavors.indexOf("caramel") !== -1;
    var wantVanR = prefs.flavors.indexOf("vanilla") !== -1;
    for (hf = 0; hf < (sku.flavors || []).length; hf++) {
      var fn = sku.flavors[hf];
      if ((wantCarR && /caramel|toffee|honey/.test(fn)) || (wantVanR && fn === "vanilla") || (!wantCarR && !wantVanR && /caramel|vanilla|honey|toffee/.test(fn))) {
        if (hits.indexOf(fn) === -1) hits.push(fn);
      }
    }
    if (hits.length) return capBit(hits.join(" and ")) + " note on this bag.";
    if (sku.handle === "caramel") return "Caramel flavored bag.";
    if (sku.handle === "french-vanilla") return "Vanilla flavored bag.";
  }
  if (sku.kind === "flavored" || prefs.lane === "sweet" || (prefs.kind && prefs.kind.indexOf("flavored") !== -1)) {
    var note = (sku.flavors && sku.flavors[0]) || "sweet";
    if (prefs.avoid && prefs.avoid.indexOf("chocolate") !== -1) {
      if (/chocolate|mocha|cocoa/.test(String(note).toLowerCase())) {
        var alt = "";
        var nf;
        for (nf = 0; nf < (sku.flavors || []).length; nf++) {
          if (!/chocolate|mocha|cocoa/.test(sku.flavors[nf])) { alt = sku.flavors[nf]; break; }
        }
        note = alt || "spice";
      }
      if (/chocolate|mocha|cocoa/.test(String(note).toLowerCase())) {
        return "Earth and spice, no chocolate.";
      }
    }
    return capBit(note) + " flavored bag for a sweet cup.";
  }
  if (prefs.acidity && prefs.acidity.indexOf("low") !== -1) {
    return "Low acid, " + (sku.roast === "dark" ? "dark" : "bold") + (brew ? " " + brew : " cup") + ".";
  }
  if (sku.acidity === "high" || (prefs.roast && prefs.roast.indexOf("light") !== -1) || prefs.lane === "fruit") {
    return "Bright " + name + (brew ? " for " + brew : "") + ".";
  }
  if (sku.roast === "dark") {
    return "Dark and bold" + (brew ? " for " + brew : "") + ".";
  }
  if (prefs.brand === "legendary" && sourceOf(sku) === "legendary") {
    return "Legendary Aviation bag that fits this brief.";
  }
  if (brew) return name + " for " + brew + ".";
  return name + " for a daily cup.";
}

function regionWord(prefs) {
  if (prefs.region === "africa") return "Africa";
  if (prefs.region === "latam") return "Latin America";
  if (prefs.region === "asia") return "Asia Pacific";
  if (prefs.lane === "fruit") return "Africa";
  if (prefs.lane === "choc") return "Latin America";
  if (prefs.lane === "earth") return "Asia Pacific";
  return "";
}

function matchReply(prefs, text) {
  prefs = prefs || {};
  var q = String(text || prefs._q || "").toLowerCase();
  var prev = (state.lastResult && state.lastResult.reply) || "";
  var reply = "";
  var avoidChoc = (prefs.avoid && prefs.avoid.indexOf("chocolate") !== -1)
    || /(?:^|[^a-z])(?:no|not|without|less)\s+(?:chocolate|mocha|cocoa|hazelnut|nutty)/.test(q);
  var spicyAsk = /spicy|more\s+spice|\bspiced\b/.test(q) || (prefs.flavors && prefs.flavors.indexOf("spice") !== -1);
  var smoothAsk = /smooth|mellow|low acid|less acid/.test(q) || (prefs.acidity && prefs.acidity.indexOf("low") !== -1);
  q = normalizeAsk(q);
  var dessertAsk = isDessertAsk(q, prefs);
  if (dessertAsk) {
    var dbits = [];
    if (/salted/.test(q) && /caramel/.test(q)) dbits.push("salted caramel");
    else {
      if (/caramel/.test(q) || (prefs.flavors && prefs.flavors.indexOf("caramel") !== -1)) dbits.push("caramel");
      if (/vanilla/.test(q) || (prefs.flavors && prefs.flavors.indexOf("vanilla") !== -1)) dbits.push("vanilla");
      if (!dbits.length && /honey/.test(q)) dbits.push("honey");
      if (!dbits.length) dbits.push("dessert-sweet");
    }
    var dline = dbits.length === 2 ? (dbits[0].charAt(0).toUpperCase() + dbits[0].slice(1) + " and " + dbits[1]) : (dbits[0].charAt(0).toUpperCase() + dbits[0].slice(1));
    reply = avoidChoc ? ("Copy. " + dline + ", no chocolate.") : ("Copy. " + dline + ".");
  } else if (avoidChoc || /spicy|more\s+spice|\bspiced\b/.test(q)) {
    var parts = [];
    if (spicyAsk) parts.push("spicy");
    if (smoothAsk) parts.push("smooth");
    if (avoidChoc) parts.push("no chocolate");
    if (!parts.length) parts.push("no chocolate");
    if (parts.length === 3) reply = "Copy. Spicy and smooth, no chocolate.";
    else if (parts.length === 2 && parts[1].indexOf("no ") === 0) reply = "Copy. " + parts[0].charAt(0).toUpperCase() + parts[0].slice(1) + ", " + parts[1] + ".";
    else if (parts.length === 2) reply = "Copy. " + parts[0].charAt(0).toUpperCase() + parts[0].slice(1) + " and " + parts[1] + ".";
    else reply = "Copy. " + parts[0].charAt(0).toUpperCase() + parts[0].slice(1) + ".";
  } else if ((/colombia|columbia|columbian|colombian/.test(q) || prefs.country === "colombia") && !avoidChoc) {
    reply = "Copy. Colombia. Chocolate and nut, now bags from that origin.";
  } else if ((prefs.hot || (/\bhot\b/.test(q) && /coffee|brew|cup|drip/.test(q))) && !avoidChoc) {
    reply = "Copy. Hot drip, not iced. Same chocolate and nut brief, brewed hot.";
  } else if (/\bdarker\b|\bbolder\b/.test(q)) {
    reply = "Copy. Darker roast on the same brief.";
  } else if (/\bbrighter\b/.test(q)) {
    reply = "Copy. Brighter cup. Lighter roast, more lift.";
  } else if (/less acid|low acid|no acid/.test(q)) {
    reply = "Copy. Lower acid on this set.";
  } else if (/more like that/.test(q)) {
    reply = "Copy. Same lane, fresh bags.";
  } else if (prefs.brand === "legendary" || /legend/.test(q)) {
    reply = "Copy. Legendary Aviation bags that fit this brief.";
  } else if (prefs.unsure) {
    var flavorBit = "";
    if (prefs.lane === "fruit") flavorBit = " Fruit-forward.";
    else if (prefs.lane === "choc") flavorBit = " Chocolate and nut.";
    else if (prefs.lane === "earth") flavorBit = " Earth and spice.";
    else if (prefs.lane === "sweet") flavorBit = " Sweet.";
    reply = "Copy. First bag." + flavorBit + " Start with a flight from our ready-room lineup.";
  } else {
    var bits = [];
    var rw = regionWord(prefs);
    if (rw) bits.push(rw);
    if (prefs.roast.indexOf("light") !== -1) bits.push("light");
    else if (prefs.roast.indexOf("dark") !== -1) bits.push("dark");
    else if (prefs.roast.indexOf("medium-dark") !== -1) bits.push("medium-dark");
    else if (prefs.roast.indexOf("medium") !== -1) bits.push("balanced");
    if (prefs.lane === "fruit") bits.push("fruit-forward");
    else if (avoidChoc) bits.push("no chocolate");
    else if (prefs.lane === "choc") bits.push("chocolate and nut");
    else if (prefs.lane === "earth") bits.push("earth and spice");
    else if (prefs.lane === "sweet" || (prefs.kind && prefs.kind.indexOf("flavored") !== -1)) bits.push("sweet");
    else if (prefs.decaf) bits.push("decaf");
    else if (prefs.flavors && prefs.flavors.length) bits.push(prefs.flavors[0]);
    if (prefs.hot || (prefs.brew && prefs.brew.indexOf("drip") !== -1)) bits.push("hot drip");
    if (bits.length) reply = "Copy. " + bits.join(", ") + ". Here is the closest ready-room match.";
    else if (prefs.decaf) reply = "Copy. Decaf. Here is the closest ready-room match.";
    else reply = "Copy. Here is the closest ready-room match.";
  }
  if (reply && prev && reply === prev) {
    reply = dessertAsk ? "Copy. Fresh bags for that flavor." : "Copy. Fresh set.";
  }
  return reply;
}

function tradeIsOn() {
  var t = window.FC_TRADE || {};
  var url = t.url == null ? "" : String(t.url).trim();
  return !!(t.enabled && url);
}

// 2026-10-25 family-safe (Martin): dark-name bags sit out family/kid/gift/holiday asks unless named (same list as Fly server)
var FC_DARK_NAMES = ["soulless-ginger-snap", "serial-killer-vanilla-butter-cream", "bloodbath-red-velvet-cake", "stay-awake-murderously-caffeinated", "drink-from-the-skull-of-your-enemy™-dark-roast", "fear-no-evil™-black-roast", "ride-or-die™-med-roast", "ride-or-die-kups-12pk", "rage-against-the-dying-of-the-light™-med-roast", "rage-kups-12pk", "my-little-friend-dark-colombian"];
var FC_FAMILY_SAFE_RX = /\b(?:famil(?:y|ies)|kids?|children|child|grandkids?|grandparents?|grandma|grandpa|nana|parents|in-laws|mom|mother|dad|father|daughter|son|toddler|baby|church|gifts?|present|stocking|stuffers?|birthday|bday|christmas|xmas|holidays?|santa|thanksgiving|friendsgiving|hanukkah|easter|halloween|trick[- ]or[- ]treat|teacher|wedding|baby shower)\b/i;
function fcDarkBlocked(sku, text) {
  if (!sku || FC_DARK_NAMES.indexOf(sku.handle) === -1) return false;
  var t = String(text || "");
  if (!FC_FAMILY_SAFE_RX.test(t)) return false;
  var n = function (s) { return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim(); };
  var name = n(String(sku.title || "").split(" - ")[0]);
  return !(name && (" " + n(t) + " ").indexOf(" " + name + " ") !== -1);
}
function localMatch(text, prefs) {
  prefs = prefs || parsePrefs(text);
  if (!prefs._q) prefs._q = String(text || "");
  var exclude = {};
  var ei;
  for (ei = 0; ei < shownHandles.length; ei++) exclude[shownHandles[ei]] = true;
  var ranked = CATALOG.map(function (sku) {
    return {
      sku: sku,
      score: scoreSku(sku, prefs),
      raw: scoreSku(sku, prefs, true),
      reason: reasonFor(sku, prefs)
    };
  }).sort(function (a, b) { return b.score - a.score; });

  var tradeOn = tradeIsOn();
  var bestRaw = ranked.length ? ranked[0].raw : 0;
  var hornetCompetitive = bestRaw >= HORNET_MIN_COMPETITIVE;
  var hornetLimit = (!tradeOn || hornetCompetitive) ? 3 : 2;

  var picks = [];
  var seen = {};
  function familyKey(sku) {
    var t = String((sku && sku.title) || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
    if (t) return "t:" + t;
    return "h:" + String((sku && sku.handle) || "").replace(/-\d+$/, "");
  }
  function add(item) {
    if (!item || !item.sku || seen[item.sku.handle]) return;
    var fam = familyKey(item.sku);
    if (seen[fam]) return;
    seen[item.sku.handle] = true;
    seen[fam] = true;
    picks.push(item);
  }
  var leftover = [];
  var dessertAskPick = isDessertAsk(text, prefs);
  var askMint = /mint|peppermint|holiday|candy/.test(normalizeAsk(text || ""));
  for (var i = 0; i < ranked.length; i++) {
    if (ranked[i].score <= 0 && picks.length) continue;
    if (dessertAskPick && !askMint && mintHolidaySku(ranked[i].sku)) continue;
    if (dessertAskPick && ranked[i].sku.kind === "sample" && !(prefs.kind && prefs.kind.indexOf("sample") !== -1) && !prefs.unsure) continue;
    if (fcDarkBlocked(ranked[i].sku, text)) continue;
    if (exclude[ranked[i].sku.handle]) leftover.push(ranked[i]);
    else if (picks.length < hornetLimit) add(ranked[i]);
  }
  for (var li = 0; li < leftover.length && picks.length < hornetLimit; li++) add(leftover[li]);
  if (prefs.unsure) {
    var best = ranked.filter(function (x) { return x.sku.handle === BEST_SELLERS; })[0];
    if (best) {
      if (!seen[BEST_SELLERS]) {
        if (picks.length >= hornetLimit) picks[picks.length - 1] = best;
        else picks.unshift(best);
        seen[BEST_SELLERS] = true;
      } else if (picks[0] && picks[0].sku.handle !== BEST_SELLERS) {
        picks = [best].concat(picks.filter(function (x) { return x.sku.handle !== BEST_SELLERS; })).slice(0, hornetLimit);
      }
    }
  }
  picks = picks.slice(0, hornetLimit);

  var includeTrade = tradeOn && !hornetCompetitive;
  var products = picks.map(function (p) {
    return { handle: p.sku.handle, reason: p.reason, sku: p.sku, source: p.sku.source || "hornet" };
  });
  var pi;
  for (pi = 0; pi < products.length; pi++) {
    if (products[pi].handle && shownHandles.indexOf(products[pi].handle) === -1) shownHandles.push(products[pi].handle);
  }
  if (shownHandles.length > 18) shownHandles = shownHandles.slice(-12);
  if (includeTrade) {
    products.push({
      title: "More specialty roasters",
      source: "trade",
      href: String(window.FC_TRADE.url).trim(),
      reason: "If you want to look beyond our ready-room bags, this network of independent roasters is a strong next stop."
    });
  }

  var reply = matchReply(prefs, text);
  if (includeTrade) {
    reply += " If you want to look further, one option from other specialty roasters is below. We may earn a commission if you buy through that link, at no extra cost to you.";
  }

  return { reply: reply, products: products };
}

var FC_VARIANT_HINT = {};
function hintedVariant(productJs) {
  var h = productJs && productJs.handle, hint = h && FC_VARIANT_HINT[h];
  if (!hint) return undefined;
  var vs = (productJs.variants || []).filter(function (v) { return v && v.available !== false; });
  var want = hint.title.toLowerCase().replace(/[^a-z0-9]/g, "");
  for (var i = 0; i < vs.length; i++) if (hint.id && String(vs[i].id) === hint.id) return vs[i];
  for (var j = 0; j < vs.length; j++) if (want && String(vs[j].title || "").toLowerCase().replace(/[^a-z0-9]/g, "").indexOf(want) !== -1) return vs[j];
  return null; // hinted variant sold out or missing: never fall back to another variant
}
function normalizeRemote(data, prefs) {
  var products = [];
  var list = (data && data.products) || [];
  var dessertAskRemote = isDessertAsk((prefs && prefs._q) || "", prefs);
  var askMintRemote = /mint|peppermint|holiday|candy/.test(normalizeAsk((prefs && prefs._q) || ""));
  for (var i = 0; i < list.length && products.length < 3; i++) {
    var handle = list[i].handle;
    var sku = byHandle(handle);
    if (!sku) continue;
    if (dessertAskRemote && !askMintRemote && mintHolidaySku(sku)) continue;
    products.push({
      handle: handle,
      reason: list[i].reason || reasonFor(sku, prefs || parsePrefs("")),
      sku: sku,
      best: !!list[i].best,
      badge: list[i].badge || "",
      variantHint: list[i].variant || "",
      variantId: list[i].variant_id || "",
      variantPrice: list[i].variant_price || "",
      quantity: list[i].quantity || 1 // 2026-10-29 H-27: carry server qty to data-qty
    });
    // 2026-10-21 pod-system variant hint (e.g. Old Salt "Kcup / 10 count"): Add / Subscribe / sticky bar / monthly all go
    // through pickVariant, which reads this map, so a K-Cup pick can never add whole bean or ground.
    if (list[i].variant || list[i].variant_id) FC_VARIANT_HINT[handle] = { title: String(list[i].variant || ""), id: String(list[i].variant_id || "") };
    else delete FC_VARIANT_HINT[handle];
  }
  if (!products.length) {
    if (data && data.reply) return { reply: data.reply, products: [] };
    return null;
  }
  return { reply: (data && data.reply) || "Here is the route.", products: products };
}


function meetRoasterHtml(sku) {
  if (!sku) return "";
  var blurb = String(sku.roaster_blurb || "").trim();
  var story = String(sku.story_url || "").trim();
  var video = String(sku.video_url || "").trim();
  var podcast = String(sku.podcast_url || "").trim();
  if (!blurb && !story && !video && !podcast) return "";
  // Only show copy Store/Collective provided — never invent farms or interviews.
  var label = blurb || story || podcast ? "Meet the roaster" : "Ready Room film";
  var html = '<div class="fc-meet-roaster"><div class="fc-meet-roaster-label">' + esc(label) + "</div>";
  if (blurb) html += '<p class="fc-meet-roaster-blurb">' + esc(blurb) + "</p>";
  var links = [];
  if (story) links.push('<a class="fc-meet-roaster-link" href="' + esc(story) + '" target="_blank" rel="noopener">Story</a>');
  if (video) links.push('<a class="fc-meet-roaster-link" href="' + esc(video) + '" target="_blank" rel="noopener">Watch</a>');
  if (podcast) links.push('<a class="fc-meet-roaster-link" href="' + esc(podcast) + '" target="_blank" rel="noopener">Listen</a>');
  if (links.length) html += '<div class="fc-meet-roaster-links">' + links.join(" · ") + "</div>";
  html += "</div>";
  return html;
}

function cardHtml(item, kind, idx) {
  var isExt = !!(item && (item.source === "trade" || item.href));
  var sku = item.sku || byHandle(item.handle) || item;
  var img = sku.image
    ? '<img class="fc-card-img" src="' + esc(sku.image) + '" alt="" width="72" height="72" loading="lazy" onerror="this.onerror=null;this.style.visibility=\'hidden\'">'
    : '<div class="fc-card-img fc-card-ph" aria-hidden="true"></div>';
  var price = item.variantPrice ? "$" + esc(item.variantPrice) : sku.price ? "$" + esc(sku.price) : "";
  var multi = item.multiVariant;
  var action;
  var titleHref;
  var meta;
  var titleAttr = "";
  if (isExt) {
    titleHref = item.href || shopUrl(item.handle || "");
    titleAttr = ' target="_blank" rel="noopener"';
    action = '<a class="fc-add fc-add--link" href="' + esc(titleHref) + '" target="_blank" rel="noopener">See other roasters</a>';
    meta = '<span class="fc-card-meta fc-card-meta-ext">External. Commission possible.</span>';
  } else if (kind === "gear") {
    titleHref = shopUrl(item.handle);
    action = multi
      ? '<a class="fc-add fc-add--link" href="' + shopUrl(item.handle) + '">Pick size</a>'
      : '<button type="button" class="fc-add" data-add-gear="' + esc(item.handle) + '">Add this</button>';
    meta = '<span class="fc-card-meta">' + esc(price) + "</span>";
  } else {
    titleHref = shopUrl(item.handle);
    if (sku.available === false) {
      action = '<a class="fc-add fc-add--link" href="' + shopUrl(item.handle) + '">See bag</a>';
    } else {
      var bagName = sku.title || item.title || "this bag";
      var qtyAttr = ' data-qty="' + fcQty(item.quantity) + '"';
      var lead = kind === "coffee" && idx === 0;
      var oneTap = '<button type="button" class="fc-add fc-add--one' + (lead ? ' fc-add--primary" data-title="' + esc(bagName) + '" data-price="' + esc(price) : '') + '" data-add="' + esc(item.handle) + '"' + qtyAttr + (lead ? ' data-fc-my-match="1" aria-label="Add my match: ' + esc(bagName) + '"' : '') + '>' + (lead ? "Add my match" : ("Add " + esc(bagName))) + (price ? (" · " + price) : "") + "</button>";
      var clubTap = clubBtn(item.handle, item.variantPrice || sku.price);
      // 2026-10-28 buy-now: one-tap cart permalink (/cart/{variant}:1 -> checkout with Shop Pay / Apple Pay / Google Pay). Add to cart stays secondary.
      var buyNow = '<a class="fc-add fc-add--buy" href="' + shopUrl(item.handle) + '" data-buy-now="' + esc(item.handle) + '"' + qtyAttr + '>Buy it now</a>';
      action = '<div class="fc-atc">' + buyNow + oneTap + clubTap + "</div>";
    }
    var sourceBit = sourceOf(sku) === "legendary"
      ? '<span class="fc-card-meta">Legendary Aviation</span>'
      : '<span class="fc-card-meta fc-card-meta-ext">Ready-room lineup</span>';
    meta = '<span class="fc-card-meta">' + esc(price) + "</span>" + sourceBit;
  }
  return (
    '<div class="fc-card' + (item.best ? ' fc-card--best' : '') + '">' +
      (item.best ? '<span class="fc-best-badge">' + esc(item.badge || "Best match") + '</span>' : '') +
      '<div class="fc-card-row">' +
        img +
        '<span class="fc-card-body">' +
          '<a class="fc-card-title" href="' + esc(titleHref) + '"' + titleAttr + ">" + esc(sku.title || item.title || item.handle) + "</a>" +
          '<span class="fc-card-reason">' + esc(item.reason || "") + "</span>" +
          meta +
        "</span>" +
      "</div>" +
      action +
      ((kind === "coffee" || (!isExt && kind !== "gear")) ? meetRoasterHtml(sku) : "") +
    "</div>"
  );
}

/* sticky-checkout (2026-10-20): scroll only the chat log, never the page, so the app bar (Shop / Cart) stays on screen. */
/* layout fix 2026-10-31 (Trevor 6:23 PM CT): the page is one natural scroll now, so bring the anchor into view in the page and never pin the page to the top. */
function fcScrollLogTo(anchor) {
  try {
    var y = (window.scrollY || window.pageYOffset || 0) + anchor.getBoundingClientRect().top - 8;
    try { window.scrollTo({ top: Math.max(0, y), behavior: "smooth" }); } catch (e1) { window.scrollTo(0, Math.max(0, y)); }
  } catch (err) {}
}
function fcPinPage() {
  return;
  try {
    var w = document.getElementById("flight-concierge");
    if (w && (window.scrollY || window.pageYOffset) > 0 && w.getBoundingClientRect().top < 0) window.scrollTo(0, 0);
  } catch (err) {}
}

function addBubble(role, html, opts) {
  var div = document.createElement("div");
  div.className = "fc-msg fc-msg--" + role;
  div.innerHTML = html;
  logEl.appendChild(div);
  if (!(opts && opts.skipScroll)) logEl.scrollTop = logEl.scrollHeight;
  return div;
}

function gearNudgeItems() {
  var tee = null;
  var hoodie = null;
  var crew = null;
  var i;
  for (i = 0; i < GEAR_FALLBACK.length; i++) {
    var g = GEAR_FALLBACK[i];
    var t = String(g.title || g.handle || "").toLowerCase();
    if (!tee && /tee|t-shirt|tshirt/.test(t)) tee = g;
    if (!hoodie && /hoodie/.test(t)) hoodie = g;
    if (!crew && /crew|sweatshirt/.test(t) && !/hoodie/.test(t)) crew = g;
  }
  var picks = [];
  if (tee) picks.push(tee);
  if (hoodie) picks.push(hoodie);
  else if (crew) picks.push(crew);
  if (!picks.length) picks = GEAR_FALLBACK.slice(0, 2);
  return picks.slice(0, 2).map(function (g) {
    return {
      title: g.title,
      handle: g.handle,
      image: g.image,
      price: g.price,
      multiVariant: true,
      reason: "Kit for the ready room."
    };
  });
}

function capMatchProducts(products, maxN) {
  maxN = maxN || 3;
  var addable = [];
  var rest = [];
  var seen = {};
  var i;
  for (i = 0; i < (products || []).length; i++) {
    var item = products[i];
    if (!item) continue;
    var h = item.handle || (item.sku && item.sku.handle) || "";
    if (h && seen[h]) continue;
    if (h) seen[h] = true;
    var sku = item.sku || byHandle(item.handle);
    var ok = !(item.source === "trade" || item.href) && sku && sku.handle && sku.available !== false;
    if (ok) addable.push(item);
    else rest.push(item);
  }
  return addable.concat(rest).slice(0, maxN);
}

function samplePackCtaHtml() {
  var pack = byHandle(BEST_SELLERS);
  if (!pack || pack.available === false) return "";
  var price = pack.price ? ("$" + esc(pack.price)) : "$24.99";
  var title = pack.title || "Best Sellers Sample Pack";
  var img = pack.image
    ? '<img class="fc-sample-cta__img" src="' + esc(pack.image) + '" alt="" width="88" height="88" loading="lazy">'
    : "";
  return (
    '<div class="fc-sample-cta">' +
      '<div class="fc-sample-cta__row">' +
        img +
        '<div class="fc-sample-cta__body">' +
          '<div class="fc-sample-cta__kicker">Not sure yet?</div>' +
          '<div class="fc-sample-cta__title">' + esc(title) + "</div>" +
          '<div class="fc-sample-cta__price">' + price + " · six staples in one flight</div>" +
        "</div>" +
      "</div>" +
      '<button type="button" class="fc-add fc-sample-cta__btn" data-add="' + esc(BEST_SELLERS) +
        '" data-variant="' + esc(SAMPLE_PACK_VARIANT) + '">Add sample pack</button>' +
      '<p class="fc-sample-cta__trust">First route not right? 14-day rematch. Email the order number.</p>' +
    "</div>"
  );
}

function wingmanCheckoutHtml() {
  return (
    '<div class="fc-wingman-note" role="note">' +
      '<p class="fc-wingman-note__promo">$7 off your first bag with code WINGMAN, limited to the next 20 orders.</p>' +
      '<p class="fc-wingman-note__soft">If you love it, snap a pic with your bag and tell us what you think — optional, not required for the deal.</p>' +
    "</div>"
  );
}

/* match-first 2026-10-23: email save offered only after a match is shown. Posts to Shopify's native customer (newsletter) form. */
function emailSaveHtml(top) {
  var name = top ? ((top.sku && top.sku.title) || (byHandle(top.handle) || {}).title || top.title || "") : "";
  return '<form class="fc-email-save" method="post" action="/contact#fc-email-save" accept-charset="UTF-8">' +
    '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
    '<input type="hidden" name="contact[tags]" value="newsletter,flight-concierge">' +
    '<input type="hidden" name="contact[note]" value="' + esc(name ? ("Concierge match: " + name) : "Concierge match") + '">' +
    '<label class="fc-email-save__label" for="fc-email-save-in">Save this match to your inbox</label>' +
    '<div class="fc-email-save__row"><input id="fc-email-save-in" class="fc-email-save__in" type="email" name="contact[email]" placeholder="you@email.com" autocomplete="email" required>' +
    '<button type="submit" class="fc-add fc-add--ghost fc-email-save__btn">Save</button></div>' +
  "</form>";
}

function renderResult(roleText, result) {
  if (window.FC_V2) return renderResultV2(roleText, result);
  var stale = logEl.querySelectorAll(".fc-cards, .fc-route-actions, .fc-closer, .fc-sample-cta, .fc-wingman-note, .fc-results-foot, .fc-monthly, .fc-email-save");
  var si;
  for (si = 0; si < stale.length; si++) {
    if (stale[si].parentNode) stale[si].parentNode.removeChild(stale[si]);
  }
  var cards = "";
  var products = capMatchProducts((result && result.products) || [], 3);
  if (products.length) {
    cards = "<div class=\"fc-cards\">" + products.map(function (item, i) { return cardHtml(item, "coffee", i); }).join("") + "</div>";
    fcBeacon("first_match", { n: products.length });
    cards += wingmanCheckoutHtml();
    var alreadyPack = false;
    var pi;
    for (pi = 0; pi < products.length; pi++) {
      if (products[pi] && products[pi].handle === BEST_SELLERS) alreadyPack = true;
    }
    var cta = alreadyPack ? "" : samplePackCtaHtml();
    cards += cta || '<p class="fc-results-foot">First route not right? 14-day rematch. Email the order number.</p>';
    cards += emailSaveHtml(products[0]);
    try {
      var p0 = products[0] || {}, s0 = p0.sku || byHandle(p0.handle) || p0;
      fcPub("fc_match_shown", { handle: String(p0.handle || ""), price: String(p0.variantPrice || s0.price || ""), n: products.length });
    } catch (errp) {}
  }
  var lines = String(roleText || "").split(/\n+/).filter(function (l) { return l.trim(); });
  var textHtml = lines.map(function (l, i) {
    return '<p class="fc-line' + (i === 0 ? ' fc-line--play' : '') + (/^Best match:/.test(l) ? ' fc-line--best' : '') +
      (/^(On your |Pod-safe:|Hot:|Iced or cold:|(?:Fine|Medium|Medium-fine|Coarse|Fine-medium) grind)/.test(l) ? ' fc-line--brew' : '') + '">' + esc(l) + "</p>";
  }).join("");
  var bubble = addBubble("bot", textHtml + cards, products.length ? { skipScroll: 1 } : null);
  if (products.length && bubble) {
    // 2026-10-21: start at the reply text (incl. brew notes), not card 1, so the brew lines are never above the fold
    var anchor = bubble;
    var rc = bubble.querySelectorAll(".fc-cards > .fc-card");
    products.forEach(function (it, i) {
      if (rc[i] && it && it.handle && !it.href && it.source !== "trade") roastedBy(rc[i], it.handle);
      if (rc[i] && it && it.handle && FC_VARIANT_HINT[it.handle]) hintedImage(rc[i], it.handle);
    });
    monthlyAdd(bubble, products);
    try { if (window.fcStickyBag1) window.fcStickyBag1(bubble); } catch (err) {}
    fcScrollLogTo(anchor);
  }
}


/* redesign 2026-10-31 (Trevor approved 10/31 5:15 PM CT): two matches. Match 1 hero (Buy now + monthly toggle), match 2 "Try something different" (Add to cart). */
function fcV2Price(item, sku) { return item.variantPrice ? "$" + esc(item.variantPrice) : sku.price ? "$" + esc(sku.price) : ""; }
function fcV2Hero(item) {
  var sku = item.sku || byHandle(item.handle) || item;
  var name = sku.title || item.title || item.handle;
  var price = fcV2Price(item, sku);
  var q = fcQty(item.quantity);
  var img = sku.image ? '<img class="fc-v2-hero__img fc-card-img" src="' + esc(sku.image) + '" alt="' + esc(name) + '" loading="eager" onerror="this.onerror=null;this.style.visibility=\'hidden\'">' : "";
  var avail = sku.available !== false;
  var planId = readyRoomPlanFor(item.handle), club = planId ? clubPriceText(item.variantPrice || sku.price) : "";
  var sub = avail && planId && club
    ? '<label class="fc-v2-sub"><input type="checkbox" class="fc-v2-sub__in" data-plan="' + esc(planId) + '"> Make it monthly · Ready Room Club · ' + club + '/mo</label>'
    : "";
  var buy = avail
    ? '<a class="fc-add fc-add--primary fc-add--buy fc-v2-buy" href="' + shopUrl(item.handle) + '" data-buy-now="' + esc(item.handle) + '" data-qty="' + q + '" data-title="' + esc(name) + '" data-price="' + esc(price) + '">Buy now' + (price ? " · " + price : "") + (q > 1 ? " (" + q + " bags)" : "") + '</a>'
    : '<a class="fc-add fc-add--link" href="' + shopUrl(item.handle) + '">See bag</a>';
  var add = avail ? '<button type="button" class="fc-add fc-add--ghost fc-v2-addlink" data-add="' + esc(item.handle) + '" data-qty="' + q + '" data-fc-my-match="1" data-title="' + esc(name) + '" data-price="' + esc(price) + '">Add to cart instead</button>' : "";
  return '<div class="fc-card fc-card--best fc-v2-hero" data-handle="' + esc(item.handle) + '">' +
    '<span class="fc-best-badge">Your match</span>' + img +
    '<a class="fc-card-title fc-v2-hero__title" href="' + shopUrl(item.handle) + '">' + esc(name) + '</a>' +
    '<span class="fc-v2-stars" hidden></span>' +
    '<p class="fc-card-reason">' + esc(item.reason || "") + '</p>' +
    '<p class="fc-v2-price">' + esc(price) + '</p>' + sub +
    '<div class="fc-atc fc-v2-actions">' + buy + add + '</div></div>';
}
function fcV2Alt(item) {
  var sku = item.sku || byHandle(item.handle) || item;
  var name = sku.title || item.title || item.handle;
  var price = fcV2Price(item, sku);
  var img = sku.image ? '<img class="fc-card-img" src="' + esc(sku.image) + '" alt="" width="72" height="72" loading="lazy" onerror="this.onerror=null;this.style.visibility=\'hidden\'">' : '<div class="fc-card-img fc-card-ph" aria-hidden="true"></div>';
  var act = sku.available === false
    ? '<a class="fc-add fc-add--link" href="' + shopUrl(item.handle) + '">See bag</a>'
    : '<button type="button" class="fc-add fc-add--one" data-add="' + esc(item.handle) + '" data-qty="' + fcQty(item.quantity) + '">Add to cart' + (price ? " · " + price : "") + '</button>';
  return '<div class="fc-card fc-v2-alt" data-handle="' + esc(item.handle) + '"><p class="fc-v2-alt__kicker">Try something different</p>' +
    '<div class="fc-card-row">' + img + '<span class="fc-card-body"><a class="fc-card-title" href="' + shopUrl(item.handle) + '">' + esc(name) + '</a>' +
    '<span class="fc-card-reason">' + esc(item.reason || "") + '</span></span></div>' + act + '</div>';
}
function fcV2Email(products) {
  if (!window.FC_KLAVIYO || !window.FC_KLAVIYO.company_id) return "";
  return '<form class="fc-v2-email" id="fc-v2-email" novalidate>' +
    '<label class="fc-v2-email__opt"><input type="checkbox" id="fc-v2-email-ok"> Email me my match + brewing tips</label>' +
    '<div class="fc-v2-email__row" hidden><input type="email" id="fc-v2-email-in" placeholder="you@email.com" autocomplete="email"><button type="submit" class="fc-add fc-add--ghost">Send</button></div>' +
    '<p class="fc-v2-email__msg" role="status"></p></form>';
}
function fcV2Stars(card, h) {
  // Judge.me: only when a per-product badge is reachable; never invents a rating.
  if (!window.FC_JDGM || !card) return;
  var el = card.querySelector(".fc-v2-stars");
  fetch("/products/" + encodeURIComponent(h) + "?view=fc-stars", { credentials: "same-origin" }).then(function (r) { return r.ok ? r.text() : ""; }).then(function (t) {
    var m = /data-average-rating=['"]([0-9.]+)['"][^>]*data-number-of-reviews=['"](\d+)['"]/.exec(t || "");
    if (!m || !el || +m[2] < 1 || +m[1] <= 0) return;
    var r = Math.round(+m[1] * 2) / 2, full = Math.floor(r), out = "";
    for (var i = 0; i < 5; i++) out += i < full ? "★" : (i === full && r % 1 ? "⯪" : "☆");
    el.innerHTML = '<span aria-hidden="true">' + out + '</span> <span class="fc-v2-stars__n">' + esc(m[1]) + " (" + esc(m[2]) + ")</span>";
    el.setAttribute("aria-label", m[1] + " out of 5 stars, " + m[2] + " reviews");
    el.hidden = false;
  }).catch(function () {});
}
function renderResultV2(roleText, result) {
  var stale = logEl.querySelectorAll(".fc-cards, .fc-route-actions, .fc-closer, .fc-sample-cta, .fc-wingman-note, .fc-results-foot, .fc-monthly, .fc-email-save, .fc-v2-email, .fc-v2-refine, .fc-v2-mail");
  for (var si = 0; si < stale.length; si++) if (stale[si].parentNode) stale[si].parentNode.removeChild(stale[si]);
  var products = capMatchProducts((result && result.products) || [], 2);
  var cards = "";
  if (products.length) {
    cards = '<div class="fc-cards fc-v2-cards">' + fcV2Hero(products[0]) + (products[1] ? fcV2Alt(products[1]) : "") + "</div>";
    cards += wingmanCheckoutHtml() + fcV2Bottom(products);
    fcBeacon("first_match", { n: products.length });
    try { var p0 = products[0] || {}, s0 = p0.sku || byHandle(p0.handle) || p0; fcPub("fc_match_shown", { handle: String(p0.handle || ""), price: String(p0.variantPrice || s0.price || ""), n: products.length }); } catch (errp) {}
  }
  var dropT = ((result && result.products) || []).slice(2).map(function (p) { var k = p && (p.sku || byHandle(p.handle)) || p || {}; return String(k.title || p.title || "").toLowerCase(); }).filter(Boolean);
  var lines = String(roleText || "").split(/\n+/).filter(function (l) {
    if (!l.trim()) return false;
    var c = l.indexOf(":"), head = (c > 0 ? l.slice(0, c) : "").toLowerCase().trim();
    return !(head && dropT.some(function (t) { return t === head || t.indexOf(head) === 0 || head.indexOf(t) === 0; }));
  });
  // two cards now: keep the reply's lead + brew lines, drop per-bag recap lines that mention a third bag
  var textHtml = lines.map(function (l, i) {
    return '<p class="fc-line' + (i === 0 ? ' fc-line--play' : '') + (/^Best match:/.test(l) ? ' fc-line--best' : '') +
      (/^(On your |Pod-safe:|Hot:|Iced or cold:|(?:Fine|Medium|Medium-fine|Coarse|Fine-medium) grind)/.test(l) ? ' fc-line--brew' : '') + '">' + esc(l) + "</p>";
  }).join("");
  var bubble = addBubble("bot", textHtml + cards, products.length ? { skipScroll: 1 } : null);
  if (products.length && bubble) {
    var rc = bubble.querySelectorAll(".fc-v2-cards > .fc-card");
    products.forEach(function (it, i) { if (rc[i] && it && it.handle && FC_VARIANT_HINT[it.handle]) hintedImage(rc[i], it.handle); });
    fcV2Stars(rc[0], products[0].handle);
    fcV2WireEmail(bubble, products);
    fcV2WireBottom(bubble, products);
    try { if (window.fcStickyBag1) window.fcStickyBag1(bubble); } catch (err) {}
    fcScrollLogTo(bubble);
  }
}
/* bottom-email 2026-10-31 (Trevor 6:46 PM CT): quiet refine line + "Email me my matches" (mailto: with a one-tap WINGMAN cart link) + "Add both to cart".
   Klaviyo switch: when window.FC_KLAVIYO has a company_id, fcV2Email (Klaviyo form) renders instead of the mailto card. FC_KLAVIYO stays null for now. */
var FC_SHOP_ORIGIN = "https://www.hornetcoffeecompany.com";
var FC_WINGMAN_LINE = "$7 off your first bag with code WINGMAN, limited to the next 20 orders.";
function fcV2Bottom(products) {
  var refine = '<p class="fc-v2-refine">Not quite? ' + ["Darker", "Brighter", "Less acid"].map(function (q) {
    return '<button type="button" class="fc-v2-refine__q" data-fc-refine="' + esc(q) + '">' + esc(q) + "</button>";
  }).join(" · ") + "</p>";
  if (window.FC_KLAVIYO && window.FC_KLAVIYO.company_id) return refine + fcV2Email(products);
  var n = products.filter(function (p) { return p && p.handle && !p.href; }).length;
  return refine + '<form class="fc-v2-mail" id="fc-v2-mail" novalidate>' +
    '<p class="fc-v2-mail__title">Email me my matches</p>' +
    '<p class="fc-v2-mail__sub">Your matches plus a one-tap checkout link, sent to you.</p>' +
    '<label class="visually-hidden" for="fc-v2-mail-in">Your email</label>' +
    '<input type="email" id="fc-v2-mail-in" class="fc-v2-mail__in" name="email" placeholder="you@email.com" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false">' +
    '<button type="submit" class="fc-add fc-add--primary fc-v2-mail__go">Email me my matches</button>' +
    '<p class="fc-v2-mail__msg" role="status"></p>' +
    (n ? '<button type="button" class="fc-add fc-add--ghost fc-v2-mail__both">' + (n > 1 ? "Add both to cart" : "Add to cart") + "</button>" : "") +
    "</form>";
}
function fcV2Lines(products) {
  return Promise.all(products.filter(function (p) { return p && p.handle && !p.href; }).map(function (p) {
    return fetchPjs(p.handle).then(function (prod) {
      var v = pickVariant(prod, state.prefs, state.grind).variant;
      var sku = p.sku || byHandle(p.handle) || p;
      if (!v || !v.id || v.available === false) return null;
      return { handle: p.handle, id: v.id, qty: fcQty(p.quantity), title: sku.title || p.title || prod.title || p.handle,
        price: p.variantPrice ? "$" + p.variantPrice : (typeof v.price === "number" ? "$" + (v.price / 100).toFixed(2) : (sku.price ? "$" + sku.price : "")) };
    }).catch(function () { return null; });
  })).then(function (l) { return l.filter(Boolean); });
}
function fcV2CartLink(lines) {
  return FC_SHOP_ORIGIN + "/cart/" + lines.map(function (l) { return l.id + ":" + l.qty; }).join(",") + "?discount=WINGMAN&utm_source=concierge-email";
}
function fcV2Mailto(to, lines) {
  var body = "Your Hornet Flight Concierge matches:\n\n" +
    lines.map(function (l, i) { return (i + 1) + ". " + l.title + (l.price ? " - " + l.price : "") + (l.qty > 1 ? " x" + l.qty : ""); }).join("\n") +
    "\n\nOne-tap checkout with WINGMAN:\n" + fcV2CartLink(lines) + "\n\n" + FC_WINGMAN_LINE + "\n";
  return "mailto:" + encodeURIComponent(to).replace(/%40/g, "@") + "?subject=" + encodeURIComponent("Your Hornet Flight Concierge matches") + "&body=" + encodeURIComponent(body);
}
function fcV2WireBottom(bubble, products) {
  var f = bubble.querySelector("#fc-v2-mail");
  if (!f) return;
  var inp = f.querySelector("#fc-v2-mail-in"), msg = f.querySelector(".fc-v2-mail__msg"), both = f.querySelector(".fc-v2-mail__both");
  f.addEventListener("submit", function (e) {
    e.preventDefault();
    var to = String(inp.value || "").trim();
    if (!/^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]{2,}$/.test(to)) { msg.textContent = "Add a valid email first."; f.classList.add("is-err"); inp.focus(); return; }
    f.classList.remove("is-err");
    msg.textContent = "Opening your email app…";
    fcV2Lines(products).then(function (lines) {
      if (!lines.length) { msg.textContent = "Could not build the cart link. Use Buy now above."; return; }
      var href = fcV2Mailto(to, lines);
      f.setAttribute("data-mailto", href);
      try { fcBeacon("email_results", { n: lines.length, via: "mailto" }); } catch (err) {}
      if (!window.__fcNoMailNav) window.location.href = href;
    });
  });
  if (both) both.addEventListener("click", function () {
    if (both.getAttribute("data-done")) { window.location.href = "/cart"; return; }
    if (both.disabled) return;
    both.disabled = true;
    var label = both.textContent;
    both.textContent = "Adding…";
    var list = products.filter(function (p) { return p && p.handle && !p.href; });
    list.reduce(function (pr, p) { return pr.then(function () { return addByHandle(p.handle, false, "", fcQty(p.quantity)); }); }, Promise.resolve())
      .then(function () {
        try { fcApplyWingman(); } catch (err) {}
        try { fcPub("fc_add_my_match", { handle: list.map(function (p) { return p.handle; }).join(","), price: "" }); } catch (err) {}
        both.textContent = "Added ✓ · View cart";
        both.disabled = false;
        both.setAttribute("data-done", "1");
      })
      .catch(function () { both.disabled = false; both.textContent = label; msg.textContent = "Could not add right now. Try Buy now above."; });
  });
}
if (logEl) logEl.addEventListener("click", function (e) {
  var b = e.target.closest("[data-fc-refine]");
  if (!b) return;
  e.preventDefault();
  try { blurInputs(); } catch (err) {}
  route(b.getAttribute("data-fc-refine"), true);
});
function fcV2WireEmail(bubble, products) {
  var f = bubble.querySelector("#fc-v2-email");
  if (!f) return;
  var ok = f.querySelector("#fc-v2-email-ok"), row = f.querySelector(".fc-v2-email__row"), inp = f.querySelector("#fc-v2-email-in"), msg = f.querySelector(".fc-v2-email__msg");
  ok.addEventListener("change", function () { row.hidden = !ok.checked; if (ok.checked) inp.focus(); });
  f.addEventListener("submit", function (e) {
    e.preventDefault();
    var em = String(inp.value || "").trim();
    if (!ok.checked || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { msg.textContent = "Add a valid email first."; return; }
    var t = function (p) { var s = p && (p.sku || byHandle(p.handle)) || p || {}; return s.title || p && p.title || ""; };
    var a = window.__fcQuiz || {};
    var props = { fc_match1: t(products[0]), fc_match1_handle: products[0] && products[0].handle || "", fc_match2: t(products[1]), fc_match2_handle: products[1] && products[1].handle || "",
      fc_brew: (a.brew || []).join(", "), fc_temp: a.temp || "", fc_milk: [].concat(a.milk || []).join(", "), fc_more: a.more || "", fc_source: "flight-concierge" };
    var K = window.FC_KLAVIYO;
    var body = { data: { type: "subscription", attributes: { custom_source: "Flight Concierge", profile: { data: { type: "profile", attributes: { email: em, properties: props } } } },
      relationships: { list: { data: { type: "list", id: K.list_id } } } } };
    msg.textContent = "Sending…";
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(K.company_id), { method: "POST", headers: { "Content-Type": "application/json", revision: "2024-10-15" }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error("k"); msg.textContent = "Check your inbox to confirm."; f.querySelector("button").disabled = true; fcBeacon("email_opt_in"); })
      .catch(function () { msg.textContent = "Could not save that. Try again in a moment."; });
  });
}
window.fcQuizGo = function (text, answers) { window.__fcQuiz = answers || null; route(text, false); };

function seed() {
  if (input.placeholder !== GREET) addBubble("bot", "<p>" + esc(GREET) + "</p>");
  setTimeout(function () { setChips(DRINK_CHIPS); }, 80);
}

function wantedGrind(prefs, grind) {
  if (grind === "ground") {
    var brew = (prefs && prefs.brew) || [];
    if (brew.indexOf("espresso") !== -1) return ["Espresso", "Standard"];
    if (brew.indexOf("pour-over") !== -1) return ["Standard", "Coarse"];
    if (brew.indexOf("drip") !== -1 || brew.indexOf("french-press") !== -1 || brew.indexOf("cold-brew") !== -1) {
      return ["Coarse", "Standard"];
    }
    return ["Standard", "Coarse"];
  }
  /* whole, skip, null, unknown → prefer whole bean / wholebean */
  return ["Whole Bean", "Whole bean", "Wholebean"];
}

function optionNames(productJs) {
  var opts = (productJs && productJs.options) || [];
  return opts.map(function (o) {
    return typeof o === "string" ? o : String((o && o.name) || "");
  });
}

function variantGrind(productJs, variant) {
  var names = optionNames(productJs);
  for (var i = 0; i < names.length; i++) {
    var n = names[i].toLowerCase();
    if (n.indexOf("grind") !== -1 || n === "whole bean" || n.indexOf("bean") !== -1) {
      if (variant.options && variant.options[i]) return String(variant.options[i]);
      return String(variant["option" + (i + 1)] || "");
    }
  }
  var title = String(variant.title || "");
  if (/whole\s*bean/i.test(title)) return "Whole Bean";
  if (/coarse/i.test(title)) return "Coarse";
  if (/espresso/i.test(title)) return "Espresso";
  if (/standard|ground/i.test(title)) return "Standard";
  return "";
}

function looksLikeGrindOption(productJs) {
  var names = optionNames(productJs);
  for (var i = 0; i < names.length; i++) {
    var n = names[i].toLowerCase();
    if (n.indexOf("grind") !== -1 || /whole bean|ground/.test(n)) return true;
  }
  var variants = (productJs && productJs.variants) || [];
  for (var j = 0; j < variants.length; j++) {
    var t = String(variants[j].title || "").toLowerCase();
    if (/whole bean|ground|coarse|espresso|standard/.test(t)) return true;
  }
  return false;
}

function pickVariant(productJs, prefs, grind) {
  var hv = hintedVariant(productJs);
  if (hv !== undefined) return { variant: hv, matchedGrind: true };
  var variants = (productJs && productJs.variants) || [];
  var order = wantedGrind(prefs, grind);
  function available(v) { return v && v.available !== false; }
  if (order) {
    for (var f = 0; f < order.length; f++) {
      for (var i = 0; i < variants.length; i++) {
        var g = variantGrind(productJs, variants[i]);
        var title = String(variants[i].title || "");
        if ((g === order[f] || title.indexOf(order[f]) !== -1) && available(variants[i])) {
          return { variant: variants[i], matchedGrind: true };
        }
      }
    }
  }
  for (var j = 0; j < variants.length; j++) {
    if (!available(variants[j])) continue;
    if (/whole\s*bean|wholebean/i.test(variantGrind(productJs, variants[j]) + " " + variants[j].title)) {
      return { variant: variants[j], matchedGrind: true };
    }
  }
  var s = looksLikeGrindOption(productJs), z = variants.filter(available), q = /12\s*oz/i;
  if (!s) z.sort(function (a, b) { return q.test(b.title) - q.test(a.title) || a.price - b.price; });
  if (z[0]) return { variant: z[0], matchedGrind: s };
  return { variant: variants[0] || null, matchedGrind: false };
}

// 2026-10-29 H-27: per-card bag count from the proxy (product.quantity); anything missing/invalid -> 1.
function fcQty(n) {
  n = parseInt(n, 10);
  return n >= 1 && n <= 99 ? n : 1;
}

async function addByVariantId(variantId, qty) {
  var body = {
    id: Number(variantId),
    quantity: fcQty(qty),
    properties: {
      _fc_source: usage.source || "",
      _fc_brief: usage.brief || "",
      _fc_rec: usage.recs && usage.recs.length ? usage.recs.join(",") : ""
    }
  };
  var add = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body)
  });
  if (!add.ok) throw new Error("cart");
  var addedJson = await add.json();
  fcTrack(true);
  return addedJson;
}

var PJS = {};
function fetchPjs(h) {
  return PJS[h] || (PJS[h] = fetch("/products/" + encodeURIComponent(h) + ".js").then(function (r) {
    if (!r.ok) throw new Error("product");
    return r.json();
  }).catch(function (e) { delete PJS[h]; throw e; }));
}
function roastedBy(card, h) {
  fetchPjs(h).then(function (p) {
    var d = document.createElement("textarea");
    d.innerHTML = (p && p.vendor) || "";
    var v = d.value.trim().replace(/ - Shop$|, LLC$/i, "");
    var t = card.querySelector(".fc-card-title");
    if (!v || /hornet|flyboy/i.test(v) || !t || card.querySelector(".fc-roaster")) return;
    t.insertAdjacentHTML("afterend", '<span class="fc-roaster">Roasted by ' + esc(v) + "</span>");
  }).catch(function () {});
}

// 2026-10-21 K-Cup variant image: hinted cards only. Reuses the PJS cache (one /products/<h>.js per handle);
// keeps the bag shot if the variant has no featured_image, the fetch fails, or the new image fails to load.
function hintedImage(card, h) {
  fetchPjs(h).then(function (p) {
    var v = hintedVariant(p), fi = v && v.featured_image, src = fi && (fi.src || fi);
    var im = card.querySelector("img.fc-card-img");
    if (!src || typeof src !== "string" || !im) return;
    var pre = new Image();
    pre.onload = function () { im.src = src; };
    pre.src = src;
  }).catch(function () {});
}

// 2026-10-17 WINGMAN auto-apply: after a coffee Add, attach the code to this cart once per session via Shopify's
// /discount/<code> link (redirected to /cart.js, so the shopper never leaves the page). Shopify's discount settings
// decide eligibility and the 20-order limit; the promo line and terms are unchanged.
// 2026-10-21 Collabs guard: Shopify keeps one order-level code, and the last /discount/<code> wins. If the cart already
// carries any other applicable code (e.g. a creator's HORNET code), leave it alone so the creator keeps credit.
function fcOtherCodeApplied() {
  return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (c) {
      return !!(c && (c.discount_codes || []).some(function (d) {
        return d && d.applicable && String(d.code || "").toUpperCase() !== "WINGMAN";
      }));
    })
    .catch(function () { return false; });
}

function fcApplyWingman() {
  try { if (sessionStorage.getItem("fc_wingman_applied") === "1") return; } catch (e) {}
  fcOtherCodeApplied().then(function (other) {
  if (other) return;
  fetch("/discount/WINGMAN?redirect=%2Fcart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
    .then(function (r) { if (r.ok) { try { sessionStorage.setItem("fc_wingman_applied", "1"); } catch (e) {} } })
    .catch(function () {});
  });
}

// Sticky Checkout: skip the WINGMAN redirect when another applicable code is already in the cart.
document.addEventListener("click", function (e) {
  var a = e.target && e.target.closest && e.target.closest("#fc-sb-checkout");
  if (!a) return;
  e.preventDefault();
  fcOtherCodeApplied().then(function (other) {
    window.location.href = other ? "/checkout" : "/discount/WINGMAN?redirect=%2Fcheckout";
  });
});

async function addByHandle(handle, asGear, sellingPlan, qty) {
  var prod = await fetchPjs(handle);
  var variants = prod.variants || [];
  if (asGear && variants.length > 1) {
    window.location.href = shopUrl(handle);
    return { redirected: true };
  }
  var picked = asGear
    ? { variant: variants.filter(function (v) { return v.available !== false; })[0] || variants[0], matchedGrind: true }
    : pickVariant(prod, state.prefs, state.grind);
  var v = picked.variant;
  if (!v) throw new Error("novariant");
  var body = { id: v.id, quantity: asGear ? 1 : fcQty(qty) };
  if (!asGear && !picked.matchedGrind && state.grind && state.grind !== "skip") {
    body.properties = { Grind: state.grind === "whole" ? "Whole bean" : "Ground" };
  }
  if (!asGear) {
    if (!body.properties) body.properties = {};
    body.properties._fc_source = usage.source || "";
    body.properties._fc_brief = usage.brief || "";
    body.properties._fc_rec = usage.recs && usage.recs.length ? usage.recs.join(",") : "";
  }
  if (sellingPlan) {
    if (asGear || readyRoomPlanFor(handle) !== String(sellingPlan)) throw new Error("plan");
    body.selling_plan = Number(sellingPlan);
  }
  var add = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body)
  });
  if (!add.ok) throw new Error("cart");
  var addedJson = await add.json();
  if (!asGear) fcTrack(true);
  return addedJson;
}

function preferGear(list) {
  var scored = list.map(function (p) {
    var h = p.handle || "";
    var t = String(p.title || "").toLowerCase();
    var idx = GEAR_PREF.indexOf(h);
    var bonus = 0;
    if (idx !== -1) bonus += 40 - idx;
    if (/tee|t-shirt|tshirt/.test(t)) bonus += 8;
    if (/hoodie/.test(t)) bonus += 7;
    if (/\bhat\b|cap/.test(t)) bonus += 6;
    return { p: p, s: bonus };
  });
  scored.sort(function (a, b) { return b.s - a.s; });
  return scored.map(function (x) { return x.p; }).slice(0, 4);
}

async function loadGear() {
  try {
    var res = await fetch("/collections/wingman-gear/products.json");
    if (res.ok) {
      var data = await res.json();
      var list = (data.products || []).map(function (p) {
        var img = "";
        if (p.images && p.images[0]) img = p.images[0].src || p.images[0];
        var price = "";
        if (p.variants && p.variants[0]) price = p.variants[0].price;
        return {
          title: p.title,
          handle: p.handle,
          image: img,
          price: price,
          multiVariant: (p.variants || []).length > 1,
          reason: "Squadron kit."
        };
      });
      var picked = preferGear(list);
      if (picked.length) return picked;
    }
  } catch (e) {}
  return GEAR_FALLBACK.map(function (g) {
    return {
      title: g.title,
      handle: g.handle,
      image: g.image,
      price: g.price,
      multiVariant: true,
      reason: "Squadron kit."
    };
  });
}

async function showGearStep() {
  state.gearShown = true;
  state.step = "gear";
  addBubble("bot", '<p class="fc-wait">Checking the ready room…</p>');
  var wait = logEl.lastElementChild;
  var gear = await loadGear();
  if (wait && wait.parentNode) wait.parentNode.removeChild(wait);
  var cards = '<div class="fc-cards">' + gear.map(function (g) { return cardHtml(g, "gear"); }).join("") + "</div>";
  var skip =
    '<div class="fc-skip-row">' +
      '<a class="fc-add fc-add--ghost" href="/checkout">Skip to checkout</a>' +
      '<a class="fc-add fc-add--ghost" href="/cart">View cart</a>' +
    "</div>";
  addBubble("bot", "<p>Coffee is in the cart. Add Wingman Gear with it, or skip to checkout.</p>" + cards + skip);
  setChips([
    { q: "Skip to checkout", label: "Skip to checkout", href: "/checkout" },
    { q: "View cart", label: "View cart", href: "/cart" }
  ]);
}

function hasFlavor(prefs) {
  if (!prefs) return false;
  if (prefs.lane) return true;
  if (prefs.flavors && prefs.flavors.length) return true;
  if (prefs.kind && prefs.kind.indexOf("flavored") !== -1) return true;
  return false;
}

function hasRoast(prefs) {
  return !!(prefs && prefs.roast && prefs.roast.length);
}

function laneLocksRegion(prefs) {
  return !!(prefs && (prefs.lane === "fruit" || prefs.lane === "choc" || prefs.lane === "earth"));
}

function skipRemainingProbes(prefs) {
  if (!prefs) return false;
  if (prefs.decaf) return true;
  if (prefs.kind.indexOf("flavored") !== -1) return true;
  if (prefs.brew.indexOf("pods") !== -1) return true;
  if (prefs.kind.indexOf("instant") !== -1) return true;
  if (prefs.brew.length && (hasFlavor(prefs) || hasRoast(prefs))) return true;
  return false;
}

function nextProbe(prefs) {
  if (!prefs) return "flavor";
  if (state.probesAsked >= 3) return null;
  if (prefs.unsure) {
    if (!hasFlavor(prefs) && !state.asked.flavor) return "flavor";
    return null;
  }
  if (state.probesAsked === 0 && skipRemainingProbes(prefs)) return null;
  if (!hasFlavor(prefs) && !state.asked.flavor) return "flavor";
  if (prefs.lane === "sweet" || prefs.kind.indexOf("flavored") !== -1) return null;
  if (!hasRoast(prefs) && !state.asked.roast) return "roast";
  if (!prefs.region && !prefs.regionAny && !laneLocksRegion(prefs) && !state.asked.region) return "region";
  return null;
}

function askProbe(kind) {
  state.asked[kind] = true;
  state.probesAsked += 1;
  state.step = kind;
  if (kind === "flavor") {
    var prior = normalizeAsk(state.lastText || "");
    if (/reeses|peanut|chocolate|cocoa|cookies?\s*(and|&)\s*cream|caramel|vanilla|pizza/.test(prior)) {
      addBubble("bot", "<p>Darker cocoa, or sweeter milk-chocolate?</p>");
      setChips([
        { q: "Darker cocoa, same brief", label: "Darker cocoa" },
        { q: "Sweeter milk chocolate, same brief", label: "Sweeter milk chocolate" }
      ]);
    } else {
      addBubble("bot", "<p>What do you want in the cup?</p>");
      setChips(FLAVOR_CHIPS);
    }
  } else if (kind === "roast") {
    addBubble("bot", "<p>Light, balanced, or dark?</p>");
    setChips(ROAST_CHIPS);
  } else if (kind === "region") {
    addBubble("bot", "<p>Any region, or no preference?</p>");
    setChips(REGION_CHIPS);
  }
}

async function route(text, fromChip) {
  if (busy) return;
  text = String(text || "").replace(/\s+/g, " ").trim();
  if (!text) return;
  if (!__fcCatalogReady) {
    __fcPending = [text, fromChip];
    if (sendBtn) { sendBtn.classList.add("fc-send--wait"); sendBtn.setAttribute("aria-busy", "true"); }
    return;
  }

  if (/^skip to checkout$/i.test(text)) {
    window.location.href = "/checkout";
    return;
  }
  if (/^view cart$/i.test(text)) {
    window.location.href = "/cart";
    return;
  }

  noteUsage(text, !!fromChip);

  var grindGuess = parseGrind(text);
  var incoming = parsePrefs(text);
  incoming._q = text;
  var drinkLike = incoming.brew.length || incoming.roast.length || incoming.flavors.length || incoming.kind.length || incoming.decaf || incoming.unsure || incoming.lane || incoming.region || incoming.regionAny || incoming.brand || incoming.hot || incoming.country || (incoming.avoid && incoming.avoid.length);
  var drinkChip = isDrinkChip(text);

  if (isResetChip(text)) {
    resetToGreeting("New brief. Tell us what flavors you like, coffee or not, and what you’re brewing in. We’ll match " + (window.FC_V2 ? "two bags" : "three bags") + " to you.");
    busy = false;
    sendBtn.disabled = false;
    afterRoute(fromChip);
    return;
  }

  busy = true;
  sendBtn.disabled = true;
  addBubble("user", "<p>" + esc(text) + "</p>");
  messages.push({ role: "user", content: text });

  if (state.step === "grind" && grindGuess) {
    state.grind = grindGuess;
  } else if (state.step === "grind" && !grindGuess) {
    state.prefs = mergePrefs(state.prefs, incoming);
    if (skipGrind(state.prefs, (state.lastText || "") + " " + text)) {
      state.grind = "skip";
    } else {
      addBubble("bot", "<p>Whole bean or ground?</p>");
      setChips(GRIND_CHIPS);
      busy = false;
      sendBtn.disabled = false;
      afterRoute(fromChip);
      return;
    }
  }

  if (state.step === "drink" || state.step === "flavor" || state.step === "roast" || state.step === "region" || state.step === "recs" || state.step === "gear" || !state.prefs) {
    state.prefs = state.prefs ? mergePrefs(state.prefs, incoming) : incoming;
    state.lastText = state.lastText ? state.lastText + " " + text : text;
    if (grindGuess) state.grind = grindGuess;
  }
  if (state.prefs) state.prefs._q = text;

  if (drinkChip || drinkLike || state.step === "recs" || state.step === "gear") {
    state.grind = state.grind || "skip";
  }

  state.grind = state.grind || "skip";

  if (fromChip) {
    state.prefs = applyStarterBrew(text, state.prefs);
    fcBeacon("chip", { q: String(text || "").slice(0, 80) });
  } else if (STARTER_QS[String(text || "").trim()]) {
    state.prefs = applyStarterBrew(text, state.prefs);
  }

  addBubble("bot", '<p class="fc-wait">Routing…</p>');
  var wait = logEl.lastElementChild;
  var result = null;
  var prefs = state.prefs;
  var endpoint = window.FC_ENDPOINT;
  var outboundMessages = messages;
  if (prefs && prefs.brew && prefs.brew.length && (fromChip || STARTER_QS[String(text || "").trim()])) {
    var brewHint = " Brew: " + prefs.brew[0] + (prefs.brew[0] === "drip" ? " (Mr. Coffee drip)." : ".");
    outboundMessages = messages.slice();
    var last = outboundMessages[outboundMessages.length - 1];
    if (last && last.role === "user" && String(last.content || "").indexOf("Brew:") === -1) {
      outboundMessages[outboundMessages.length - 1] = {
        role: "user",
        content: String(last.content || "") + brewHint
      };
    }
  }
  if (endpoint && String(endpoint).trim()) {
    try {
      var res = await fetch(String(endpoint).trim(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(window.__fcQuiz ? { messages: outboundMessages, grind: state.grind, prefs: prefs, shown: shownHandles, quiz: window.__fcQuiz } : { messages: outboundMessages, grind: state.grind, prefs: prefs, shown: shownHandles })
      });
      if (res.ok) result = normalizeRemote(await res.json(), prefs);
    } catch (e) {
      result = null;
    }
  }
  if (!result) result = localMatch(text, prefs);

  if (wait && wait.parentNode) wait.parentNode.removeChild(wait);
  renderResult(result.reply, result);
  noteRecs(result);
  messages.push({ role: "assistant", content: result.reply });
  state.lastResult = result;
  state.step = "recs";
  var gotProducts = result && result.products && result.products.length;
  if (gotProducts) setChips(REFINE_CHIPS);
  else setChips(BREW_FOLLOWUP_CHIPS);
  busy = false;
  sendBtn.disabled = false;
  afterRoute(fromChip);
}

form.addEventListener("submit", function (e) {
  e.preventDefault();
  var val = input.value;
  input.value = "";
  blurInputs();
  route(val, false);
});
input.addEventListener("keydown", function (e) {
  if (e.key === "Enter" && !e.shiftKey) {
    e.preventDefault();
    form.requestSubmit();
  }
});
chips.addEventListener("click", function (e) {
  var btn = e.target.closest("[data-q]");
  if (!btn) return;
  blurInputs();
  var href = btn.getAttribute("data-href");
  if (href) {
    window.location.href = href;
    return;
  }
  var q = btn.getAttribute("data-q");
  if (q === "Just talk") {
    if (input) input.focus();
    return;
  }
  if (isResetChip(q)) {
    resetToGreeting("New brief. Tell us what flavors you like, coffee or not, and what you’re brewing in. We’ll match " + (window.FC_V2 ? "two bags" : "three bags") + " to you.");
    return;
  }
  route(q, true);
});


/* sticky-bag1 (2026-10-14): mobile bar mirrors bag #1 and forwards taps to its card button (same add path) */
(function () {
  var bar = document.getElementById("fc-stickybar");
  var shell = bar && bar.parentNode;
  var sbAdd = document.getElementById("fc-sb-add");
  var inp = document.getElementById("fc-input");
  if (!bar || !sbAdd) return;
  var target = null, mo = null;
  function sync() {
    if (!target) return;
    var ok = target.classList.contains("fc-add--ok");
    var n = window.fcCartN || 0;
    var co = document.getElementById("fc-sb-checkout");
    if (ok && n > 0 && co) {
      co.textContent = "Checkout (" + (n > 99 ? "99+" : n) + ")";
      co.setAttribute("aria-label", "Checkout, " + n + (n === 1 ? " item" : " items") + " in cart");
      co.hidden = false;
      sbAdd.hidden = true;
      return;
    }
    if (co) co.hidden = true;
    sbAdd.hidden = false;
    sbAdd.disabled = !!target.disabled;
    sbAdd.textContent = ok ? "Added" : "Add to cart";
    sbAdd.classList.toggle("fc-add--ok", ok);
  }
  window.fcStickySync = sync;
  window.fcStickyBag1 = function (bubble) {
    var p = bubble && bubble.querySelector(".fc-cards > .fc-card .fc-add--primary[data-add]");
    if (mo) { mo.disconnect(); mo = null; }
    target = p || null;
    if (!p) { bar.hidden = true; shell.classList.remove("fc-has-bag1"); return; }
    document.getElementById("fc-sb-title").textContent = p.getAttribute("data-title") || "";
    document.getElementById("fc-sb-price").textContent = p.getAttribute("data-price") || "";
    sync();
    if (window.MutationObserver) { mo = new MutationObserver(sync); mo.observe(p, { attributes: true, childList: true, subtree: true, characterData: true }); }
    bar.hidden = false;
    shell.classList.add("fc-has-bag1");
  };
  sbAdd.addEventListener("click", function (e) {
    e.preventDefault(); e.stopPropagation();
    if (target && target.isConnected && !target.disabled) target.click();
  });
  if (inp) {
    inp.addEventListener("focus", function () { document.documentElement.classList.add("fc-typing"); });
    inp.addEventListener("blur", function () { document.documentElement.classList.remove("fc-typing"); });
  }
})();

var fcRoot = document.getElementById("flight-concierge") || logEl;
// 2026-10-28 buy-now: resolve the same variant Add would pick, then go to the cart permalink. Falls back to the bag page (href).
fcRoot.addEventListener("click", function (e) {
  var bn = e.target.closest("[data-buy-now]");
  if (!bn) return;
  e.preventDefault();
  if (bn.getAttribute("aria-busy") === "true") return;
  var h = bn.getAttribute("data-buy-now");
  bn.setAttribute("aria-busy", "true");
  try { fcBeacon("buy_now", { handle: String(h || "") }); } catch (err) {}
  var subIn = bn.closest(".fc-v2-hero") && bn.closest(".fc-v2-hero").querySelector(".fc-v2-sub__in:checked");
  if (subIn) {
    addByHandle(h, false, subIn.getAttribute("data-plan"), bn.getAttribute("data-qty")).then(function () { return fcOtherCodeApplied(); }).then(function (other) { window.location.href = other ? "/checkout" : "/discount/WINGMAN?redirect=%2Fcheckout"; }).catch(function () { bn.removeAttribute("aria-busy"); window.location.href = bn.getAttribute("href"); });
    return;
  }
  fetchPjs(h).then(function (prod) {
    var v = pickVariant(prod, state.prefs, state.grind).variant;
    if (!v || !v.id || v.available === false) throw new Error("novariant");
    // 2026-10-31 buynow-wingman: permalink carries WINGMAN unless the cart already holds another applicable code.
    var link = "/cart/" + v.id + ":" + fcQty(bn.getAttribute("data-qty"));
    return fcOtherCodeApplied().then(function (other) { window.location.href = other ? link : link + "?discount=WINGMAN"; });
  }).catch(function () {
    bn.removeAttribute("aria-busy");
    window.location.href = bn.getAttribute("href");
  });
});
fcRoot.addEventListener("click", function (e) {
  var addBtn = e.target.closest("[data-add]");
  var gearBtn = e.target.closest("[data-add-gear]");
  if (!addBtn && !gearBtn) return;
  e.preventDefault();
  var handle = addBtn ? addBtn.getAttribute("data-add") : gearBtn.getAttribute("data-add-gear");
  var btn = addBtn || gearBtn;
  var variantId = addBtn ? (addBtn.getAttribute("data-variant") || "") : "";
  var rawPlan = addBtn ? (addBtn.getAttribute("data-selling-plan") || "") : "";
  var sellingPlan = "";
  if (rawPlan) {
    if (variantId || readyRoomPlanFor(handle) !== rawPlan) return;
    sellingPlan = rawPlan;
  }
  if ((!handle && !variantId) || btn.disabled) return;
  btn.disabled = true;
  if (addBtn && addBtn.getAttribute("data-fc-my-match") === "1") {
    fcPub("fc_add_my_match", { handle: String(handle || ""), price: String(addBtn.getAttribute("data-price") || "") });
  }
  var prev = btn.textContent;
  btn.textContent = "Adding…";
  var addPromise = (addBtn && variantId)
    ? addByVariantId(variantId, addBtn.getAttribute("data-qty"))
    : addByHandle(handle, !!gearBtn, sellingPlan, addBtn ? addBtn.getAttribute("data-qty") : 1);
  addPromise
    .then(function (out) {
      if (out && out.redirected) return;
      afterAtcOk(btn, "Added ✓");
      if (addBtn) fcApplyWingman();
      if (addBtn && variantId) {
        addBubble("bot", "<p>Sample pack is in the cart. Taste the flight, then pick a full bag when you are ready.</p>" + '<div class="fc-skip-row"><a class="fc-add fc-add--ghost" href="/cart">View cart</a></div>');
      } else if (addBtn && sellingPlan) {
        addBubble("bot", "<p>Same bag, every month, at the club price. It is in the cart. Checkout when you are ready.</p>" + '<div class="fc-skip-row"><a class="fc-add fc-add--ghost" href="/cart">View cart</a></div>');
      } else if (addBtn) {
        addBubble("bot", "<p>Coffee is in the cart. Stay here if you want the rest of the route, or head to checkout when you are ready.</p>" + '<div class="fc-skip-row"><a class="fc-add fc-add--ghost" href="/cart">View cart</a></div>');
      } else {
        addBubble("bot", "<p>That is in the cart.</p>");
      }
    })
    .catch(function () {
      btn.textContent = prev;
      btn.disabled = false;
      fcBeacon("atc_fail");
      addBubble("bot", "<p>Could not add that from here. Open the product to finish.</p>");
    });
});

(function () {
  var L = document.getElementById("fc-cart-link");
  if (!L) return;
  L.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    try { if (openCartDrawer()) return; } catch (err) {}
    location.assign("/cart");
  }, true);
})();
seed();
(function () {
  function cc() { fcCartCount().catch(function () {}); }
  if (document.readyState === "complete") setTimeout(cc, 0); else window.addEventListener("load", cc);
  window.addEventListener("pageshow", function (e) { if (e.persisted) cc(); });
})();

// Phase 1 catalog scale (2026-10-12): load CATALOG from assets/fc-catalog.json
(function loadFcCatalogFromAsset() {
  var el = document.getElementById("fc-catalog");
  var src = el && el.getAttribute("data-src");
  function finish(data) {
    CATALOG.length = 0;
    var i, row;
    data = Array.isArray(data) ? data : [];
    for (i = 0; i < data.length; i++) CATALOG.push(data[i]);
    expandFcCatalog(CATALOG);
    enrichCatalogRegions();
    __fcCatalogReady = true;
    var send = document.getElementById("fc-send");
    if (send) { send.disabled = false; send.classList.remove("fc-send--wait"); send.removeAttribute("aria-busy"); }
    if (__fcPending) { var pend = __fcPending; __fcPending = null; route(pend[0], pend[1]); }
  }
  if (!src) {
    try { finish(JSON.parse((el && el.textContent) || "[]")); } catch (e) { finish([]); }
    return;
  }
  fetch(src, { credentials: "same-origin" }).then(function (r) {
    if (!r.ok) throw new Error("catalog " + r.status);
    return r.json();
  }).then(finish).catch(function () { finish([]); });
})();

})();
